// import './iscroll-zoom.js'
import { initSwipeEvents, enableSwiping, disableSwiping } from './CciSwipeEvents.js'
import CciArticleLayer from './layers/CciArticleLayer.vue'
import CciClickableAdLayer from './layers/CciClickableAdLayer.vue'
import CciWidgetLayer from './layers/CciWidgetLayer.vue'
import CciZoomAreaLayer from './layers/CciZoomAreaLayer.vue'
import Cropper from 'cropperjs'
// import { CciDataSourceUpdatePages, CciDataSourceClearMemory, pages } from 'model/CciDataSource.js'
// import {Spinner} from 'spin.js'
// import '../../../node_modules/spin.js/spin.css'

/* eslint-disable no-unused-vars */

// import * as pdfjsLib from './pdf-webpack'

// import * as PdfjsWorker from 'pdfjs-dist/build/pdf.worker.js'

// import { PDFSinglePageViewer } from 'pdfjs-dist/web/pdf_viewer'
// import { EventBus } from 'pdfjs-dist/web/pdf_viewer'
import { PageZoom } from './CciPageZoom.js'

import {
  mapGetters
} from 'vuex'

export default {
  props: ['slideIndex', 'pageContainerSize'],
  data () {
    return {
      // zoomer: null,
      // doubleClickZoomLevel: 1.0,
      clickCount: 0,
      clickTimer: null,
      leftArticles: [],
      rightArticles: [],
      leftClickableAds: [],
      rightClickableAds: [],
      leftWidgets: [],
      rightWidgets: [],
      leftZoomObjects: [],
      rightZoomObjects: [],
      cropper: null,
      cropperOnScreen: false,
      cropperIsMoving: false,
      leftThumbPageIsLoaded: false,
      rightThumbPageIsLoaded: false,
      initPage: null,
      page: undefined,
      trackAnimateZoomEvent: '',
      shouldScrollToRight: false,
      doubleClickViewportScale: 3.0,
      leftPdfPage: null,
      rightPdfPage: null,
      pageZoomer: null,
      leftPageLoaded: false,
      rightPageLoaded: false,
      isRenderingLeftPdfPage: false,
      isRenderingRightPdfPage: false,
      leftPageLoadingTask: null,
      rightPageLoadingTask: null,
      leftPageRenderingTask: null,
      rightPageRenderingTask: null,
      renderLeftPdfPageOnScroll: false,
      renderRightPdfPageOnScroll: false,
      canvasSizeLimitMin: 380000,
      canvasSizeLimitMax: 268435456, // default is desktop limit
      shouldLayoutPages: true,
      showLoadingSpinner: false,
    }
  },
  created () {
    // pdfjsLib = this.getPdfJsLib()
    // window.addEventListener('mi_micb_loaded', this.fireInitPageTrackingEvent, false)
    window.addEventListener('buttonZoomIn', this.zoomInFromButton, false)
    window.addEventListener('buttonZoomOut', this.zoomOutFromButton, false)
    window.addEventListener('pdfjsloaded', this.startPdfLoading, false)

    this.pdfjsLib = this.$store.state.pdfjsLib

    // limits. desktop: 268435456, mobile/tablet: 16777216
    if (this.isPhone() || this.isTablet()) {
      this.canvasSizeLimitMax = 16777216
    } else if (this.isSafari()) {
      // Safari has performance problems - so we will reduce the canvas size limit a lot...
      this.canvasSizeLimitMax = 20000000
    }
  },
  mounted () {
    this.page = this.getPageFromSlideIndex()

    // this page slide may actually be an "empty slot" that does not need to have any content. 
    if (this.page === undefined) { return }

    this.makeElements()

    // if (this.page.firstPage.id === this.currentPage.firstPage.id) {
      // this page slide is the first page that is shown when loading the web reader.
    this.initPage = this.page

    if (this.isTablet() || this.isPhone()) {
      const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
      pageWrapper.style.marginLeft = '10px'
      pageWrapper.style.marginRight = '10px'
    }

    // load the thumbnail(s).
    if (!this.page.firstPage.isInterstitialAdPlaceholder) {
      this.loadPageThumbnails()
    } else {
      this.fireInterstitialIsReadyEvent()
    }
    
    if (!this.initPageLoaded) {
      // Scroll previous page to the right at init.
      let currentPageIndex = this.indexOfPage(this.pages, this.currentPage)
      let pageIndex = this.indexOfPage(this.pages, this.page)
      let isPrevPage = pageIndex == currentPageIndex - 1
      if (isPrevPage) {
        this.shouldScrollToRight = true
      }
    }
  },
  computed: {
    ...mapGetters({
      opsUrl: 'getOpsUrl',
      showOverlay: 'getShowOverlay',
      currentPage: 'getCurrentPage',
      pages: 'getPages',
      singlePagesNoAds: 'getSinglePagesNoAds',
      sections: 'getSections',
      settings: 'getSettings',
      maxZoom: 'getMaxZoom',
      // adsEnabled: 'getAdsEnabled',
      showCrop: 'getShowCrop',
      isFullPageViewMode: 'getPageViewMode',
      initPageLoaded: 'getInitPageLoaded',
      isScrolling: 'getIsScrolling',
      isCurrentPageLoaded: 'getIsCurrentPageLoaded',
      slidesPageIndexes: 'getSlidesPageIndexes'
    })
  },
  watch: {
    pages (newPages, oldPages) {
      if (this.page === undefined) { return }
      // pages array has changed 
      // This happens if an interstitial has been inserted/removed before/after current page.
      // Or if the view changed to from displaying double pages to single pages or vice versa.

      // first find the current displayed page in the new array.
      // what page is this?
      const newIndexOfCurrentPage = this.indexOfPage(newPages, this.currentPage)
      const oldIndexOfCurrentPage = this.indexOfPage(oldPages, this.currentPage)

      if (this.page.firstPage.id === this.currentPage.firstPage.id && newPages.indexOf(this.page) === -1) {
        //This is the current page but the pages changed from double to single or vice versa.
        // We need to update to current page content.
        this.updatePage(this.currentPage)
        return
      }

      // Am I the old previous or next page?
      if (this.indexOfPage(oldPages, this.page) === oldIndexOfCurrentPage - 1) {
        const newPage = newPages[newIndexOfCurrentPage - 1]

        // Did my content change?
        if (newPage !== this.page) {
          // new content!
          this.updatePage(newPage)
        }
      } else if (this.indexOfPage(oldPages, this.page) === oldIndexOfCurrentPage + 1) {
        const newPage = newPages[newIndexOfCurrentPage + 1]

        // Did my content change?
        if (newPage !== this.page) {
          // new content!
          this.updatePage(newPage)
        }
      }
    },
    pageContainerSize: function (newContainerSize) {
      if (this.page === undefined) { return }
      const self = this
      clearTimeout(this.pageHeightTimeout)
      this.pageHeightTimeout = setTimeout(function() {
        if (self.page.firstPage.isInterstitialAdPlaceholder) { 
          // Set size of interstitial ad placeholder 
          self.sizeInterstitialAdPlaceholder()
          return 
        }

        // We need to disply the thumbnails to calculate the new size of the pages
        self.displayPageThumbnails()
        // Set the new size of the thumbail pages
        self.sizePageThumbnails()

        if (self.leftPageLoaded && self.rightPageLoaded) {
          // replace the thumbnails with the bitmaps
          if (useBitmapPages) {
            self.displayFirstPageBitmap()
            self.displaySecondPageBitmap()
          } else {
            self.reScalePdfs()
          }
        }
      }, 300)
    },
    currentPage: function () {
      if (this.page === undefined) { return }

      this.startLoadingThisPage()
    },
    showCrop: function (newValue) {
      if (this.page === undefined || this.page.firstPage.id !== this.currentPage.firstPage.id || !newValue && this.cropper === null) {
        return
      }
      if (!newValue) {
        if (this.pageZoomer !== null) {
          this.destroyCropper()
          this.pageZoomer.enable()
          this.pageZoomer.zoomToMinScale()
          // this.renderPdfPages()
        }
        return
      }

      this.destroyCropper()
      disableSwiping()

      if (this.pageZoomer) {
        this.pageZoomer.zoomToMinScale()
        if (!this.isFullPageViewMode) {
          this.pageZoomer.fitToHeight()
        }
        if (document.getElementById(this._uid + 'page-wrapper').offsetWidth < document.getElementById(this._uid + 'page-left-container').offsetWidth) {
          this.pageZoomer.fitToWidth(true)
        }
      }

      this.showLoadingSpinner = true
      useBitmapPages ? this.displayCropTool() : this.renderPdfPages(true)
    },
    isCurrentPageLoaded () {
      this.layoutZoomButtons()
    }
  },
  methods: {
    getPageIndexFromActiveSlideIndex () {
      for (var i = 0; i < this.slidesPageIndexes.length; i++) {
        if (this.slidesPageIndexes[i] === this.slideIndex) {
          return i
        }
      }
    },
    resetPage () {
      this.destroyPageZoom()
      this.destroyCanvases()
      this.leftThumbPageIsLoaded = false
      this.rightThumbPageIsLoaded = false
      this.leftPageLoaded = false
      this.rightPageLoaded = false

      this.leftArticles = []
      this.rightArticles = []
      this.leftClickableAds = []
      this.rightClickableAds = []
      this.leftWidgets = []
      this.rightWidgets = []
      this.leftZoomObjects = []
      this.rightZoomObjects = []

      this.makeElements()
    },
    makeElements () {
      const leftThumbnail = document.getElementById(this._uid + 'page-left-thumbnail')
      const rightThumbnail = document.getElementById(this._uid + 'page-right-thumbnail')
      const leftBitmap = document.getElementById(this._uid + 'page-left-bitmap')      
      const rightBitmap = document.getElementById(this._uid + 'page-right-bitmap')
      const adCont = document.getElementById(this._uid + 'interstitial-ad-container')
      if (leftThumbnail) {leftThumbnail.remove()}
      if (leftBitmap) {leftBitmap.remove()}
      if (rightThumbnail) {rightThumbnail.remove()}
      if (rightBitmap) {rightBitmap.remove()}
      if (adCont) {adCont.remove()}

      const leftContainer = document.getElementById(this._uid + 'page-left-container')

      if (this.page.firstPage.isInterstitialAdPlaceholder) {
        const intAdContainer = document.createElement('div')
        intAdContainer.setAttribute('class', 'interstitial-ad-container')
        intAdContainer.setAttribute('id', this._uid + 'interstitial-ad-container')
        leftContainer.appendChild(intAdContainer)

        const innerZoomCont = document.getElementById(this._uid + 'zoom-inner-container')
        innerZoomCont.style.transform = 'translate(0, 0)'
        innerZoomCont.style.top = '0'

      } else {
        const newLeftThumbnail = document.createElement('img')
        newLeftThumbnail.addEventListener('load', this.pageThumbnailLoaded)
        newLeftThumbnail.setAttribute('class', 'page-left-thumbnail')
        newLeftThumbnail.setAttribute('id', this._uid + 'page-left-thumbnail')
        leftContainer.appendChild(newLeftThumbnail)

        if (useBitmapPages) {
          const newLeftBitmap = document.createElement('img')
          newLeftBitmap.addEventListener('load', this.pageBitmapLoaded)
          newLeftBitmap.setAttribute('class', 'page-left-bitmap')
          newLeftBitmap.setAttribute('id', this._uid + 'page-left-bitmap')
          leftContainer.appendChild(newLeftBitmap)
        }

        if (this.page.secondPage !== null) {
          const rightContainer = document.getElementById(this._uid + 'page-right-container')

          const newRightThumbnail = document.createElement('img')
          newRightThumbnail.addEventListener('load', this.pageThumbnailLoaded) 
          newRightThumbnail.setAttribute('class', 'page-right-thumbnail')
          newRightThumbnail.setAttribute('id', this._uid + 'page-right-thumbnail')
          rightContainer.appendChild(newRightThumbnail)

          if (useBitmapPages) {
            const newRightBitmap = document.createElement('img')
            newRightBitmap.addEventListener('load', this.pageBitmapLoaded)
            newRightBitmap.setAttribute('class', 'page-right-bitmap')
            newRightBitmap.setAttribute('id', this._uid + 'page-right-bitmap')
            rightContainer.appendChild(newRightBitmap)
          }
        }
      }

      const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
      const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
      zoomWrapper.style.width = pageWrapper.style.width

      if (zoomWrapper.clientHeight > pageWrapper.clientHeight) {
        zoomWrapper.style.height = pageWrapper.style.height
      }
    },
    startLoadingThisPage () {
      if (this.pageZoomer !== null) {
        this.pageZoomer.zoomToMinScale()
        this.pageZoomer.removeEvents()
      }
      if (!this.page.firstPage.isInterstitialAdPlaceholder && (!this.leftThumbPageIsLoaded || !this.rightThumbPageIsLoaded)) {
        this.loadPageThumbnails()
        return
      }

      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        if (this.page.firstPage.isInterstitialAdPlaceholder !== undefined) {
          this.displayAdPlaceholder()
          if (!this.isDesktop()) {
            // We are only interested in swipe events on touch devices
            const pageContLeft = document.getElementById(this._uid + 'page-left-container')
            const pageContRight = document.getElementById(this._uid + 'page-right-container')
            initSwipeEvents(pageContLeft)
            initSwipeEvents(pageContRight)
          }
          return
        }

        if (this.leftThumbPageIsLoaded && !this.leftPageLoaded) {
          document.getElementById(this._uid + 'page-left-thumbnail').style.visibility = 'visible'
        }
        if (this.rightThumbPageIsLoaded && this.page.secondPage !== null && !this.rightPageLoaded) {
          document.getElementById(this._uid + 'page-right-thumbnail').style.visibility = 'visible'
        }

        if (!this.leftPageLoaded && !this.rightPageLoaded && this.leftThumbPageIsLoaded && this.rightThumbPageIsLoaded) {
          this.loadPagesAndLayers()
          return
        }

        if (this.leftPageLoaded && useBitmapPages) {
          this.displayFirstPageBitmap()
        }

        if (this.rightPageLoaded && useBitmapPages) {
          this.displaySecondPageBitmap()
        }

        if (this.pageZoomer !== null) {
          this.pageZoomer.enable()
          this.updatePageZoom(this.pageZoomer.scale)
        } else {
          this.initPageZoom(1)
          this.updatePageZoom(1)
        }
      } else {
        if (this.showCrop) {
          this.destroyCropper()
          this.$store.commit('setCropVisible', false)
        }
      }
    },
    fireInterstitialIsReadyEvent () {
      let afterPageNos = []
      const pageIndex = this.indexOfPage(this.pages, this.page)
      if (pageIndex > 0) {
        const prevPage = this.pages[pageIndex - 1]

        const firstPageNum = prevPage.firstPage.pageNumber
        afterPageNos = firstPageNum.indexOf('-') !== -1 ? [firstPageNum.split('-')[0], firstPageNum.split('-')[1]] : [firstPageNum]
        if (prevPage.secondPage !== null) {
          afterPageNos.push(prevPage.secondPage.pageNumber)
        }
      } else {
        afterPageNos.push('-1')
      }

      const detail = {
        containerElementId: this._uid + 'interstitial-ad-container',
        maxWidth: document.getElementById(this._uid + 'page-wrapper').clientWidth,
        maxHeight: document.getElementById('pages-container').clientHeight,
        afterPageNos: afterPageNos
      }
      const event = new CustomEvent('interstitialAdPageIsReady', { detail: detail })
      window.dispatchEvent(event)
    },
    updatePage (newPage) {
      if (this.page.firstPage.isInterstitialAdPlaceholder && newPage.firstPage.isInterstitialAdPlaceholder) {
        // if both old an new page is intersitial ad then no need to reset the page.
        // just update the page ref and fire interstitial ad is ready event
        this.page = newPage
        this.fireInterstitialIsReadyEvent()
        return
      }

      if (this.page.firstPage.isInterstitialAdPlaceholder && !newPage.firstPage.isInterstitialAdPlaceholder) {
        // interstitial page is replaces by a 'normal' page.
        // this happens when displaying interstitials 'per swipe'
        // send event about the destroying of the interstitial page
        this.fireInterstitialAdPageWillBeDestroyedEvent()
      }

          // set this page to the new page
      this.page = newPage
          // rebuild page
      this.resetPage()
          // load thumbnails (if any)
      if (!this.page.firstPage.isInterstitialAdPlaceholder) {
        this.loadPageThumbnails()
      } else {
        // fire interstitial is ready event if this is an interstitial ad page
        this.fireInterstitialIsReadyEvent()
      }      
    },
    loadPageThumbnails () {
      document.getElementById(this._uid + 'page-left-thumbnail').src = this.getEncodedResourceUrl(this.page.firstPage.thumbnail, this.page.firstPage.attributes.LastRev)
      if (this.page.secondPage !== null) {
          document.getElementById(this._uid + 'page-right-thumbnail').src = this.getEncodedResourceUrl(this.page.secondPage.thumbnail, this.page.secondPage.attributes.LastRev)
      }
    },
    pageThumbnailLoaded (event) {
      var elm = event.target
      if (document.getElementById(this._uid + 'page-left-thumbnail') === null) {
        // the page slide was destroyed while the thumbnail was loading.
        return
      }
      if (!this.initPageLoaded) {
        // If the high res is loaded and initial page is not yet loaded
        // -> send out a notification that the initial page is loaded.
        // We use this to wait with loading the ads until after the initial page has loaded.
        this.$store.commit('setInitPageLoaded', true)
      }

      // A thumbnail is loaded.
      if (elm.id === this._uid + 'page-left-thumbnail') {
        // Left thumbnail is loaded
        this.leftThumbPageIsLoaded = true
        elm.style.visibility = 'visible'
        if (this.page.secondPage === null) {
          // there is no second page so just set the right thumbnail as loaded.
          this.rightThumbPageIsLoaded = true
        }
      }

      if (elm.id === this._uid + 'page-right-thumbnail') {
        // Right thumbnail is loaded
        this.rightThumbPageIsLoaded = true
        elm.style.visibility = 'visible'
      }

      if (this.leftThumbPageIsLoaded && this.rightThumbPageIsLoaded) {
        // Thumbnails are loaded - set the size of the thumnails to fit current view mode
        this.sizePageThumbnails()
        this.loadPagesAndLayers()
      }
    },
    loadPageBitmaps () {
      document.getElementById(this._uid + 'page-left-bitmap').src = this.getEncodedResourceUrl(this.page.firstPage.background, this.page.firstPage.attributes.LastRev)
      if (this.page.secondPage !== null) {
          document.getElementById(this._uid + 'page-right-bitmap').src = this.getEncodedResourceUrl(this.page.secondPage.background, this.page.secondPage.attributes.LastRev)
      }
    },
    pageBitmapLoaded (event) {
      const elm = event.target
      if (elm.id === this._uid + 'page-left-bitmap') {
        this.leftPageLoaded = true
        if (this.page.secondPage === null) {
          this.rightPageLoaded = true
        }
        this.displayFirstPageBitmap()
      }
      if (elm.id === this._uid + 'page-right-bitmap') {
        this.rightPageLoaded = true
        this.displaySecondPageBitmap()
      }

      if (this.leftPageLoaded && this.rightPageLoaded) {
        this.updatePageZoom(1)
        if (this.page.firstPage.id === this.currentPage.firstPage.id) {
          this.$store.commit('setIsCurrentPageLoaded', true)
        }
      }
    },
    startPdfLoading () {
      if (useBitmapPages) {
        return
      }
      this.pdfjsLib = this.$store.state.pdfjsLib
      if (this.leftThumbPageIsLoaded && this.rightThumbPageIsLoaded) {
        // When all thumbnails are loaded -> initialize the zoomer and load the high res.
        // this.initZoomer()
        if (this.page.firstPage.id === this.currentPage.firstPage.id) {
          this.loadPagesAndLayers()
        }
      }
    },
    loadPagesAndLayers () {
      // this.freezeZoomGestures()
      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        this.$store.commit('setIsCurrentPageLoaded', false)
      }

      this.loadPageComponents()
      this.initPageZoom(1)
      if (useBitmapPages) {
        this.loadPageBitmaps()
      } else {
        this.loadLeftPdfPage()
        this.loadRightPdfPage()
      }
    },
    // loadPdfPagesWithLayers () {
    //   if (this.pdfjsLib === null) {
    //     return
    //   }
    //   // this.initZoomer()
    //   this.freezeZoomGestures()
    //   this.layoutPages()
    //   this.initPageZoom(1)
    //   if (useBitmapPages) {
    //     this.loadPageBitmaps()
    //   } else {
    //     this.loadLeftPdfPage()
    //     this.loadRightPdfPage()
    //   }
    //
    //   // Also load the page components (article, widget and clickable ad layers)
    //   this.loadPageComponents()
    // },
    loadPageComponents () {
      this.loadLeftArticles()
      this.loadLeftClickableAds()
      this.loadLeftWidgets()
      this.loadLeftZoomObjects()

      this.loadRightArticles()
      this.loadRightClickableAds()
      this.loadRightWidgets()
      this.loadRightZoomObjects()
    },
    // reScaleBitmaps () {
    //   if (!this.isFullPageViewMode) {
    //     // fit to width
    //     this.pageZoomer.isFitToWidth = true
    //     this.pageZoomer.fitToWidth()
    //   } else {
    //     this.pageZoomer.isFitToWidth = false
    //   }
    // },
    reScalePdfs () {
      this.destroyCropper()
      this.pageZoomer.zoomToMinScale()
      this.$store.commit('setCropVisible', false)
      this.cancelRenderPdfPages()
      const canvasLeft = document.getElementById(this._uid + 'page-left-pdf')
      if (canvasLeft) {
        canvasLeft.remove()
      }

      const canvasRight = document.getElementById(this._uid + 'page-right-pdf')
      if (canvasRight) {
        canvasRight.remove()
      }

      // remove text layer elements
      const leftTextLayer = document.getElementById(this._uid + 'page-left-text-layer')
      const rightTextLayer = document.getElementById(this._uid + 'page-right-text-layer')
      if (leftTextLayer !== null) {
        leftTextLayer.remove()
      }
      if (rightTextLayer !== null) {
        rightTextLayer.remove()
      }

      this.leftPageLoaded = false
      this.rightPageLoaded = false

      this.loadPagesAndLayers()
    },
    createPdfWorker () {
      const workerParams = {
        verbosity: false,
        port: this.pdfjsLib.GlobalWorkerOptions.workerPort
      }
      return workerParams.port ? this.pdfjsLib.PDFWorker.fromPort(workerParams) : new this.pdfjsLib.PDFWorker(workerParams)
    },
    loadLeftPdfPage () {
      if (this.page !== undefined && this.page.firstPage.id === this.currentPage.firstPage.id) {
        const that = this
        let canvas, textLayer

        if (this.page.secondPage === null) {
          this.rightPageLoaded = true
        }

        if (this.pageZoomer !== null) {
          this.pageZoomer.disable()
        }

        const pageUrlToLoad = this.getEncodedResourceUrl(this.page.firstPage.pdf, this.page.firstPage.attributes.LastRev)
        const worker = this.createPdfWorker()
        this.leftPageLoadingTask = this.pdfjsLib.getDocument({
          'url': pageUrlToLoad,
          'worker': worker
        })

        this.leftPageLoadingTask.promise.then(function(pdfDocument) {
            return pdfDocument.getPage(1).then(function(pdfPage) {
              that.leftPdfPage = pdfPage
              that.isRenderingLeftPdfPage = true

              // we get a viewport in the size of the pdf.
              const viewport = pdfPage.getViewport({
                scale: 1
              })

              const thumbnail = document.getElementById(that._uid + 'page-left-thumbnail')

              // we need to scale the view port to fit the size of the container.
              const viewPortScaleFactor = thumbnail.offsetHeight / viewport.height
              // that.doubleClickViewportScale = viewPortScaleFactor * that.settings.doubleClickZoomIncrease

              // scale it down to fit
              const scaledViewport = pdfPage.getViewport({
                scale: viewPortScaleFactor
              })

              let outputScale = 2
              // if (that.isFullPageViewMode) {
              //   outputScale = outputScale*2
              // }

              if ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale) < that.canvasSizeLimitMin) {
                outputScale = Math.sqrt(that.canvasSizeLimitMin / ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale)))
              }

              if ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale) > that.canvasSizeLimitMax) {
                // make sure that the canvas will not get too big for non-desktop devices.
                // If canvas-width * canvas-height > 16777216 then the browser will refuse to draw the canvas.
                outputScale = Math.sqrt(that.canvasSizeLimitMax / ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale)))
              }

              // great! now lets set the size of the canvas
              canvas = that.createLeftCanvas()
              canvas.width = scaledViewport.width * outputScale
              canvas.height = scaledViewport.height * outputScale
              canvas.style.height = thumbnail.offsetHeight + 'px'
              canvas.style.width = thumbnail.offsetWidth + 'px'
              // canvas.style.height = Math.floor(scaledViewport.height) + 'px'
              // canvas.style.width = Math.floor(scaledViewport.width) + 'px'

              const pageContainer = document.getElementById(that._uid + 'page-left-container')
              pageContainer.appendChild(canvas)

              if (that.isDesktop()) {
                textLayer = that.createLeftTextLayer()
                textLayer.style.height = thumbnail.offsetHeight + 'px'
                textLayer.style.width = thumbnail.offsetWidth + 'px'
                pageContainer.appendChild(textLayer)
              }

              const ctx = canvas.getContext('2d')

              const transform = outputScale !== 1 ?
                [outputScale, 0, 0, outputScale, 0, 0] :
                null

              // render the PDF on to the canvas
              that.leftPageRenderingTask = pdfPage.render({
                canvasContext: ctx,
                viewport: scaledViewport,
                transform: transform
              })

              that.leftPageRenderingTask.promise.then(function() {
                return pdfPage.getTextContent()
              }).then(function(textContent) {
                that.leftPageLoaded = true
                canvas.style.display = 'inline-block'
                thumbnail.style.display = 'none'
                if (!that.isFullPageViewMode) {
                  canvas.style.visibility = 'hidden'
                }

                if (textLayer !== undefined) {
                  that.pdfjsLib.renderTextLayer({
                    textContent: textContent,
                    container: textLayer,
                    viewport: scaledViewport,
                    textDivs: []
                  })
                  textLayer.style.display = 'inline-block'
                }

                that.isRenderingLeftPdfPage = false
                if (that.rightPageLoaded) {
                  that.updatePageZoom(viewPortScaleFactor)
                  that.$store.commit('setIsCurrentPageLoaded', true)
                }
              }).catch(function(err) {
                console.error('page ' + that.page.firstPage.pageNumber + ' Error: ' + err)
                canvas.remove()
                if (textLayer !== undefined) {
                  textLayer.remove()
                }
                that.isRenderingLeftPdfPage = false
              })
            })
          })
          .catch(function(reason) {
            console.error('page ' + that.page.firstPage.pageNumber + ' Error: ' + reason)
            that.isRenderingLeftPdfPage = false
            if (canvas !== undefined) {
              canvas.remove()
            }
            if (textLayer !== undefined) {
              textLayer.remove()
            }
          })
      }
    },
    loadRightPdfPage () {
      if (this.page !== undefined && this.page.firstPage.id === this.currentPage.firstPage.id && this.page.secondPage !== null) {
        const that = this
        let canvas, textLayer

        if (this.pageZoomer !== null) {
          this.pageZoomer.disable()
        }

        const pageUrlToLoad = this.getEncodedResourceUrl(this.page.secondPage.pdf, this.page.secondPage.attributes.LastRev)
        const worker = this.createPdfWorker()
        this.rightPageLoadingTask = this.pdfjsLib.getDocument({
          'url': pageUrlToLoad,
          'worker': worker
        })

        this.rightPageLoadingTask.promise
          .then(function(pdfDocument) {
            return pdfDocument.getPage(1).then(function(pdfPage) {
              that.isRenderingRightPdfPage = true
              that.rightPdfPage = pdfPage

              // we get a viewport in the size of the pdf.
              const viewport = pdfPage.getViewport({
                scale: 1
              })

              const thumbnail = document.getElementById(that._uid + 'page-right-thumbnail')

              // we need to scale the view port to fit the size of the container.
              const viewPortScaleFactor = thumbnail.offsetHeight / viewport.height

              // scale it down to fit
              const scaledViewport = pdfPage.getViewport({
                scale: viewPortScaleFactor
              })

              let outputScale = 2
              // if (that.isFullPageViewMode) {
              //   outputScale = outputScale*2
              // }

              if ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale) < that.canvasSizeLimitMin) {
                outputScale = Math.sqrt(that.canvasSizeLimitMin / ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale)))
              }

              if ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale) > that.canvasSizeLimitMax) {
                // make sure that the canvas will not get too big for non-desktop devices.
                // If canvas-width * canvas-height > 16777216 then the browser will refuse to draw the canvas.
                outputScale = Math.sqrt(that.canvasSizeLimitMax / ((scaledViewport.width * outputScale) * (scaledViewport.height * outputScale)))
              }

              // great! now lets set the size of the canvas
              canvas = that.createRightCanvas()
              canvas.width = scaledViewport.width * outputScale
              canvas.height = scaledViewport.height * outputScale
              canvas.style.height = thumbnail.offsetHeight + 'px'
              canvas.style.width = thumbnail.offsetWidth + 'px'
              // canvas.style.height = Math.floor(scaledViewport.height) + 'px'
              // canvas.style.width = Math.floor(scaledViewport.width) + 'px'

              const pageContainer = document.getElementById(that._uid + 'page-right-container')
              pageContainer.appendChild(canvas)

              if (that.isDesktop()) {
                textLayer = that.createRightTextLayer()
                textLayer.style.height = thumbnail.offsetHeight + 'px'
                textLayer.style.width = thumbnail.offsetWidth + 'px'
                pageContainer.appendChild(textLayer)
              }

              const ctx = canvas.getContext('2d')

              const transform = outputScale !== 1 ?
                [outputScale, 0, 0, outputScale, 0, 0] :
                null

              // render the PDF on to the canvas
              that.rightPageRenderingTask = pdfPage.render({
                canvasContext: ctx,
                viewport: scaledViewport,
                transform: transform
              })

              that.rightPageRenderingTask.promise.then(function() {
                return pdfPage.getTextContent()
              }).then(function(textContent) {
                // the canvas is done - hide the thumbnail and dispay the canvas
                that.isRenderingRightPdfPage = false
                that.rightPageLoaded = true
                canvas.style.display = 'inline-block'
                thumbnail.style.display = 'none'
                if (!that.isFullPageViewMode) {
                  canvas.style.visibility = 'hidden'
                }

                if (textLayer !== undefined) {
                  that.pdfjsLib.renderTextLayer({
                    textContent: textContent,
                    container: textLayer,
                    viewport: scaledViewport,
                    textDivs: []
                  })
                  textLayer.style.display = 'inline-block'
                }

                if (that.leftPageLoaded) {
                  that.updatePageZoom(viewPortScaleFactor)
                  that.$store.commit('setIsCurrentPageLoaded', true)
                }
              }).catch(function(err) {
                console.error('page ' + that.page.secondPage.pageNumber + ' Error: ' + err)
                canvas.remove()
                if (textLayer !== undefined) {
                  textLayer.remove()
                }
                that.isRenderingRightPdfPage = false
              })
            })
          })
          .catch(function(err) {
            console.error('page ' + that.page.secondPage.pageNumber + ' Error: ' + err)
            that.isRenderingRightPdfPage = false
            if (canvas !== undefined) {
              canvas.remove()
            }
            if (textLayer !== undefined) {
              textLayer.remove()
            }
          })
      }
    },
    renderLeftPdfPage (forCrop) {
      if (this.isRenderingLeftPdfPage) {
        this.isRenderingLeftPdfPage = false
        this.leftPageRenderingTask.cancel()
        return
      }
      let canvas, textLayer
      try {
        this.isRenderingLeftPdfPage = true
        this.$store.commit('setIsCurrentPageLoaded', false)
        // this.pageZoomer.disable()
        const currentCanvas = document.getElementById(this._uid + 'page-left-pdf')
        const currentTextLayer = document.getElementById(this._uid + 'page-left-text-layer')
        let outputScale = 1

        if (forCrop) {
          const cropScale = this.settings.pageCropScale !== undefined ? this.settings.pageCropScale : 2
          outputScale = outputScale*cropScale
        } else if (this.pageZoomer.minScale === this.pageZoomer.scale) {
          outputScale = outputScale*2
        }

        const canvasWidth = parseInt(currentCanvas.style.width.split('px')[0])
        const canvasHeight = parseInt(currentCanvas.style.height.split('px')[0])

        if ((canvasWidth * outputScale) * (canvasHeight * outputScale) < this.canvasSizeLimitMin) {
          outputScale = Math.sqrt(this.canvasSizeLimitMin / ((canvasWidth) * (canvasHeight)))
        }

        if ((canvasWidth * outputScale) * (canvasHeight * outputScale) > this.canvasSizeLimitMax) {
          // make sure that the canvas will not get too big for non-desktop devices.
          // If canvas-width * canvas-height > 16777216 then the browser will refuse to draw the canvas.
          outputScale = Math.sqrt(this.canvasSizeLimitMax / ((canvasWidth) * (canvasHeight)))
        }

        canvas = this.createLeftCanvas()
        canvas.width = canvasWidth * outputScale
        canvas.height = canvasHeight * outputScale
        canvas.style.height = currentCanvas.style.height
        canvas.style.width = currentCanvas.style.width

        const pageContainer = document.getElementById(this._uid + 'page-left-container')
        pageContainer.appendChild(canvas)

        if (currentTextLayer !== null) {
          textLayer = this.createLeftTextLayer()
          textLayer.style.height = currentTextLayer.style.height
          textLayer.style.width = currentTextLayer.style.width
          pageContainer.appendChild(textLayer)
        }

        const ctx = canvas.getContext('2d')

        const transform = outputScale !== 1
        ? [outputScale, 0, 0, outputScale, 0, 0]
        : null

        const scaledViewport = this.leftPdfPage.getViewport({
          scale: this.pageZoomer.scale
        })

        // render the pdf canvas
        const that = this
        this.leftPageRenderingTask = this.leftPdfPage.render({
          canvasContext: ctx,
          viewport: scaledViewport,
          transform: transform
        })

        this.leftPageRenderingTask.promise.then(function() {
          return that.leftPdfPage.getTextContent()
        }).then(function(textContent) {
          // the canvas is done - display the canvas
          const thumbnail = document.getElementById(that._uid + 'page-left-thumbnail')
          currentCanvas.remove()
          if (thumbnail !== null) {
            thumbnail.style.display = 'none'
          }
          canvas.style.display = 'inline-block'
          that.pageZoomer.setPageCanvas1(canvas)

          if (textLayer !== undefined) {
            currentTextLayer.remove()
            that.pdfjsLib.renderTextLayer({
              textContent: textContent,
              container: textLayer,
              viewport: scaledViewport,
              textDivs: []
            })
            textLayer.style.display = 'inline-block'
            that.pageZoomer.setTextLayer1(textLayer)
          }

          that.isRenderingLeftPdfPage = false
          if (that.isRenderingRightPdfPage === false) {
            that.$store.commit('setIsCurrentPageLoaded', true)
            that.pageZoomer.enable()
            if (forCrop) {
              that.displayCropTool()
            }
          }
        }).catch(function(err) {
          console.log('Error: ' + err + ' for page: ' + that.page.firstPage.pageNumber)
          canvas.remove()
          if (textLayer !== undefined) {
            textLayer.remove()
          }
          that.isRenderingLeftPdfPage = false
          if (that.pageZoomer !== null) {
            that.pageZoomer.enable()
          }
        })
      } catch (err) {
        console.log('Error: ' + err + ' for page: ' + this.page.firstPage.pageNumber)
        if (canvas !== undefined) {
          canvas.remove()
        }
        if (textLayer !== undefined) {
          textLayer.remove()
        }
        this.isRenderingLeftPdfPage = false
        if (this.pageZoomer !== null) {
          this.pageZoomer.enable()
        }
      }
    },
    renderRightPdfPage (forCrop) {
      if (this.isRenderingRightPdfPage) {
        this.isRenderingRightPdfPage = false
        this.rightPageRenderingTask.cancel()
        return
      }
      let canvas, textLayer
      try {
        this.isRenderingRightPdfPage = true
        this.$store.commit('setIsCurrentPageLoaded', false)
        const currentCanvas = document.getElementById(this._uid + 'page-right-pdf')
        const currentTextLayer = document.getElementById(this._uid + 'page-right-text-layer')
        let outputScale = 1

        if (forCrop) {
          const cropScale = this.settings.pageCropScale !== undefined ? this.settings.pageCropScale : 2
          outputScale = outputScale*cropScale
        } else if (this.pageZoomer.minScale === this.pageZoomer.scale) {
          outputScale = outputScale*2
        }

        const canvasWidth = parseInt(currentCanvas.style.width.split('px')[0])
        const canvasHeight = parseInt(currentCanvas.style.height.split('px')[0])

        if ((canvasWidth * outputScale) * (canvasHeight * outputScale) < this.canvasSizeLimitMin) {
          outputScale = Math.sqrt(this.canvasSizeLimitMin / ((canvasWidth) * (canvasHeight)))
        }

        if ((canvasWidth * outputScale) * (canvasHeight * outputScale) > this.canvasSizeLimitMax) {
          // make sure that the canvas will not get too big for non-desktop devices.
          // If canvas-width * canvas-height > 16777216 then the browser will refuse to draw the canvas.
          outputScale = Math.sqrt(this.canvasSizeLimitMax / ((canvasWidth * outputScale) * (canvasHeight * outputScale)))
        }

        canvas = this.createRightCanvas()
        canvas.width = canvasWidth * outputScale
        canvas.height = canvasHeight * outputScale
        canvas.style.height = currentCanvas.style.height
        canvas.style.width = currentCanvas.style.width

        const pageContainer = document.getElementById(this._uid + 'page-right-container')
        pageContainer.appendChild(canvas)

        if (currentTextLayer !== null) {
          textLayer = this.createRightTextLayer()
          textLayer.style.height = currentTextLayer.style.height
          textLayer.style.width = currentTextLayer.style.width
          pageContainer.appendChild(textLayer)
        }

        const ctx = canvas.getContext('2d')

        const transform = outputScale !== 1
        ? [outputScale, 0, 0, outputScale, 0, 0]
        : null

        const scaledViewport = this.rightPdfPage.getViewport({
          scale: this.pageZoomer.scale
        })

        // render the pdf canvas
        const that = this
        this.rightPageRenderingTask = this.rightPdfPage.render({
          canvasContext: ctx,
          viewport: scaledViewport,
          transform: transform
        })

        this.rightPageRenderingTask.promise.then(function() {
          return that.rightPdfPage.getTextContent()
        }).then(function(textContent) {
          const thumbnail = document.getElementById(that._uid + 'page-right-thumbnail')
          currentCanvas.remove()
          if (thumbnail !== null) {
            thumbnail.style.display = 'none'
          }
          canvas.style.display = 'inline-block'
          that.pageZoomer.setPageCanvas2(canvas)

          if (textLayer !== undefined) {
            currentTextLayer.remove()
            that.pdfjsLib.renderTextLayer({
              textContent: textContent,
              container: textLayer,
              viewport: scaledViewport,
              textDivs: []
            })
            textLayer.style.display = 'inline-block'
            that.pageZoomer.setTextLayer2(textLayer)
          }

          that.isRenderingRightPdfPage = false
          if (that.isRenderingLeftPdfPage === false) {
            that.$store.commit('setIsCurrentPageLoaded', true)
            that.pageZoomer.enable()
            if (forCrop) {
              that.displayCropTool()
            }
          }
        }).catch(function(err) {
          console.log('Error: ' + err + ' for page: ' + that.page.secondPage.pageNumber)
          canvas.remove()
          if (textLayer !== undefined) {
            textLayer.remove()
          }
          that.isRenderingRightPdfPage = false
          if (that.pageZoomer !== null) {
            that.pageZoomer.enable()
          }
        })
      } catch (err) {
        console.log('Error: ' + err + ' for page: ' + this.page.secondPage.pageNumber)
        if (canvas !== undefined) {
          canvas.remove()
        }
        if (textLayer !== undefined) {
          textLayer.remove()
        }
        this.isRenderingRightPdfPage = false
        if (this.pageZoomer !== null) {
          this.pageZoomer.enable()
        }
      }
    },
    renderPdfPages (forCrop) {
      if (this.leftPdfPage === null) {
        return
      }
      this.pageZoomer.disable()
      if (this.pageZoomer.isLeftPageInView()) {
        this.renderLeftPdfPageOnScroll = false
        this.renderLeftPdfPage(forCrop)
      } else {
        this.renderLeftPdfPageOnScroll = true
      }
      if (this.page.secondPage !== null) {
        if (this.pageZoomer.isRightPageInView()) {
          this.renderRightPdfPageOnScroll = false
          this.renderRightPdfPage(forCrop)
        } else {
          this.renderRightPdfPageOnScroll = true
        }
      }
    },
    cancelRenderPdfPages () {
      if (this.isRenderingLeftPdfPage) {
        this.isRenderingLeftPdfPage = false
        this.leftPageRenderingTask.cancel()
      }
      if (this.isRenderingRightPdfPage) {
        this.isRenderingRightPdfPage = false
        this.rightPageRenderingTask.cancel()
      }
    },
    createLeftCanvas () {
      var canvas = document.createElement('canvas')
      canvas.className = 'page-left-pdf'
      canvas.id = this._uid + 'page-left-pdf'
      canvas.style.display = 'none'
      return canvas
    },
    createRightCanvas () {
      var canvas = document.createElement('canvas')
      canvas.className = 'page-right-pdf'
      canvas.id = this._uid + 'page-right-pdf'
      canvas.style.display = 'none'
      return canvas
    },
    createLeftTextLayer () {
      let textLayer = document.createElement('div')
      textLayer.className = 'textLayer'
      textLayer.id = this._uid + 'page-left-text-layer'
      textLayer.style.display = 'none'
      return textLayer
    },
    createRightTextLayer () {
      let textLayer = document.createElement('div')
      textLayer.className = 'textLayer'
      textLayer.id = this._uid + 'page-right-text-layer'
      textLayer.style.display = 'none'
      return textLayer
    },
    loadLeftArticles () {
      var artArray = []
      if (this.page !== undefined) {
        for (var i = 0; i < this.page.firstPage.articles.length; i++) {
          var article = this.page.firstPage.articles[i]
          artArray.push(article)
        }
      }
      this.leftArticles = artArray
    },
    loadRightArticles () {
      var artArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          for (var j = 0; j < this.page.secondPage.articles.length; j++) {
            var article = this.page.secondPage.articles[j]
            artArray.push(article)
          }
        }
      }
      this.rightArticles = artArray
    },
    loadLeftWidgets() {
      var widgetArray = []
      if (this.page !== undefined) {
        for (var i = 0; i < this.page.firstPage.widgets.length; i++) {
          widgetArray.push(this.page.firstPage.widgets[i])
        }
      }
      this.leftWidgets = widgetArray
    },
    loadRightWidgets() {
      var widgetArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null) {
          for (var j = 0; j < this.page.secondPage.widgets.length; j++) {
            widgetArray.push(this.page.secondPage.widgets[j])
          }
        }
      }
      this.rightWidgets = widgetArray
    },
    loadLeftClickableAds () {
      var adArray = []
      if (this.page !== undefined) {
        if (this.page.firstPage.interstitialInfo !== null) {
          if (this.isPortrait()) {
            for (var j = 0; j < this.page.firstPage.interstitialInfo.portaitClickableAds.length; j++) {
              adArray.push(this.page.firstPage.interstitialInfo.portaitClickableAds[j])
            }
          } else {
            for (var k = 0; k < this.page.firstPage.interstitialInfo.landscapeClickableAds.length; k++) {
              adArray.push(this.page.firstPage.interstitialInfo.landscapeClickableAds[k])
            }
          }
        } else if (this.page.firstPage.clickableAds !== undefined) {
          for (var i = 0; i < this.page.firstPage.clickableAds.length; i++) {
            adArray.push(this.page.firstPage.clickableAds[i])
          }
        }
      }
      this.leftClickableAds = adArray
    },
    loadRightClickableAds () {
      var adArray = []
      if (this.page !== undefined) {
        if (this.page.secondPage !== null && this.page.secondPage.clickableAds !== undefined) {
          for (var j = 0; j < this.page.secondPage.clickableAds.length; j++) {
            adArray.push(this.page.secondPage.clickableAds[j])
          }
        }
      }
      this.rightClickableAds = adArray
    },
    loadLeftZoomObjects () {
      var zoomObjArray = []
      if (this.page !== undefined && this.page.firstPage.zoomObjects !== undefined) {
        for (var i = 0; i < this.page.firstPage.zoomObjects.length; i++) {
          zoomObjArray.push(this.page.firstPage.zoomObjects[i])
        }
      }
      this.leftZoomObjects = zoomObjArray
    },
    loadRightZoomObjects () {
      var zoomObjArray = []
      if (this.page !== undefined && this.page.secondPage !== null && this.page.secondPage.zoomObjects !== undefined) {
        for (var i = 0; i < this.page.secondPage.zoomObjects.length; i++) {
          zoomObjArray.push(this.page.secondPage.zoomObjects[i])
        }
      }
      this.rightZoomObjects = zoomObjArray
    },
    initPageZoom (initScale) {
      if (this.pageZoomer !== null || this.page.firstPage.id !== this.currentPage.firstPage.id) {
        return
      }
      // console.log('Init Page Zoomer for page ' + this.page.firstPage.pageNumber)

      if (!this.isDesktop()) {
        // We are only interested in swipe events on touch devices
        const pageContLeft = document.getElementById(this._uid + 'page-left-container')
        const pageContRight = document.getElementById(this._uid + 'page-right-container')
        initSwipeEvents(pageContLeft)
        initSwipeEvents(pageContRight)
      }

      // if (this.page.firstPage.interstitialAdAfterPage !== undefined) {
      //   return
      // }

      const container = document.getElementById(this._uid + 'page-wrapper')
      const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
      const contentContainer = document.getElementById(this._uid + 'zoom-inner-container')

      const leftThumbnail = document.getElementById(this._uid + 'page-left-thumbnail')
      let rightThumbnail = null
      if (this.page.secondPage !== null) {
        rightThumbnail = document.getElementById(this._uid + 'page-right-thumbnail')
      }

      let maxZoom = 3
      if (this.maxZoom) {
        maxZoom = this.maxZoom
      }

      const maxScale = maxZoom * initScale

      const doubleClickZoomIncrease = this.settings.doubleClickZoomIncrease !== undefined && this.settings.doubleClickZoomIncrease !== '' && this.settings.doubleClickZoomIncrease > 0 ? this.settings.doubleClickZoomIncrease : this.doubleClickViewportScale
      this.doubleClickViewportScale = (doubleClickZoomIncrease / maxZoom) * (maxZoom + initScale)

      this.unFreezeZoomGestures()

      this.pageZoomer = new PageZoom(zoomWrapper, container, {
        contentContainer: contentContainer,
        minScale: initScale,
        maxScale: maxScale,
        pageThumbnail1: leftThumbnail,
        pageThumbnail2: rightThumbnail,
        zoomWithThumbnails: !this.isDesktop(),
        doubleClickZoomScale: this.doubleClickViewportScale
      })
      this.pageZoomer.on('scrollStart', () => {
        this.$store.commit('setIsScrolling', true)
      })

      this.pageZoomer.on('scrollEnd', () => {
        setTimeout(this.scrollEnded, 500)
      })

      // this.pageZoomer.isFitToWidth = !this.isFullPageViewMode
      // if (!this.isFullPageViewMode) {
      //   // fit to width
      //   this.pageZoomer.isFitToWidth = true
      //   this.pageZoomer.fitToWidth()
      // } else {
      //   this.pageZoomer.isFitToWidth = false
      // }

      this.shouldScrollToRight ? this.pageZoomer.scrollToRight() : this.pageZoomer.scrollToLeft()
    },
    updatePageZoom (initScale) {
      if (this.pageZoomer === null || this.page.firstPage.id !== this.currentPage.firstPage.id) {
        return
      }

      const leftPage = document.getElementById(this._uid + 'page-left-pdf') !== null ? document.getElementById(this._uid + 'page-left-pdf') : document.getElementById(this._uid + 'page-left-bitmap')
      const rightPage = document.getElementById(this._uid + 'page-right-pdf') !== null ? document.getElementById(this._uid + 'page-right-pdf') : document.getElementById(this._uid + 'page-right-bitmap')
      const leftTextLayer = document.getElementById(this._uid + 'page-left-text-layer')
      const rightTextLayer = document.getElementById(this._uid + 'page-right-text-layer')

      if (leftPage === null) { return }

      let maxZoom = 3
      if (this.maxZoom) {
        maxZoom = this.maxZoom
      }

      // const maxScale = maxZoom * 1
      const doubleClickZoomIncrease = this.settings.doubleClickZoomIncrease !== undefined && this.settings.doubleClickZoomIncrease !== '' && this.settings.doubleClickZoomIncrease > 0 ? this.settings.doubleClickZoomIncrease : this.doubleClickViewportScale
      this.doubleClickViewportScale = (doubleClickZoomIncrease / maxZoom) * (maxZoom + initScale)

      this.unFreezeZoomGestures()
      this.pageZoomer.enable()

      this.pageZoomer.setPageComponents({
        minScale: initScale,
        maxScale: maxZoom,
        doubleClickZoomScale: this.doubleClickViewportScale,
        pdfPage1: this.leftPdfPage,
        pdfPage2: this.rightPdfPage,
        pageFull1: leftPage,
        pageFull2: rightPage,
        textLayer1: leftTextLayer,
        textLayer2: rightTextLayer
      })

      this.pageZoomer.off('trackpadZoomIn', this.onTrackpadZoomIn)
      this.pageZoomer.on('trackpadZoomIn', this.onTrackpadZoomIn)
      this.pageZoomer.off('trackpadZoomOut', this.onTrackpadZoomOut)
      this.pageZoomer.on('trackpadZoomOut', this.onTrackpadZoomOut)

      // this.pageZoomer.off('touchZoomStart', this.onTouchZoomStart)
      // this.pageZoomer.on('touchZoomStart', this.onTouchZoomStart)

      this.pageZoomer.off('touchZoomIn', this.onTouchZoomIn)
      this.pageZoomer.on('touchZoomIn', this.onTouchZoomIn)
      this.pageZoomer.off('touchZoomOut', this.onTouchZoomOut)
      this.pageZoomer.on('touchZoomOut', this.onTouchZoomOut)

      this.pageZoomer.off('doubleClickZoomIn', this.onDoubleClickZoomIn)
      this.pageZoomer.on('doubleClickZoomIn', this.onDoubleClickZoomIn)
      this.pageZoomer.off('doubleClickZoomOut', this.onDoubleClickZoomOut)
      this.pageZoomer.on('doubleClickZoomOut', this.onDoubleClickZoomOut)

      this.pageZoomer.off('didZoom', this.onPageDidZoom)
      this.pageZoomer.on('didZoom', this.onPageDidZoom)
      // this.pageZoomer.off('didZoomToMinScale', this.onPageDidZoom(false))
      // this.pageZoomer.on('didZoomToMinScale', this.onPageDidZoom(false))

      if (!this.isFullPageViewMode) {
        leftPage.style.visibility = 'visible'
        // if (rightCanvas !== null) {
        //   rightCanvas.style.visibility = 'visible'
        // }
        // this.renderPdfPages()
      }
    },
    // initZoomer () {
    //   if (this.zoomer !== null) {
    //     return
    //   }
    //
    //   let zoomEL = document.getElementById(this._uid + 'page-wrapper')
    //   if (!zoomEL) {
    //     return
    //   }
    //
    //   this.layoutPages()
    //
    //   if (!this.isDesktop()) {
    //     // We are only interested in swipe events on touch devices
    //     var pageContLeft = document.getElementById(this._uid + 'page-left-container')
    //     var pageContRight = document.getElementById(this._uid + 'page-right-container')
    //     initSwipeEvents(pageContLeft)
    //     initSwipeEvents(pageContRight)
    //   }
    //
    //   if (this.page.firstPage.interstitialAdAfterPage !== undefined) {
    //     return
    //   }
    //
    //   var maxZoom = 3
    //   if (this.maxZoom) {
    //     maxZoom = this.maxZoom
    //   }
    //
    //   this.zoomer = new IScroll(zoomEL, {
    //     zoom: true,
    //     zoomMax: maxZoom,
    //     scrollY: true,
    //     scrollX: true,
    //     momentum: false,
    //     mouseWheel: true,
    //     HWCompositing: !this.isSafari(),
    //     click: false,
    //     tap: this.isTouchBrowser(),
    //     keyBindings: true,
    //     bounce: false,
    //     disablePointer: this.isTouchBrowser(),
    //     disableTouch: !this.isTouchBrowser()
    //   })
    //
    //   if (this.isTouchBrowser()) {
    //     zoomEL.addEventListener('tap', this.onClickTap, false)
    //   }
    //
    //   zoomEL.addEventListener('trackpadZoomIn', this.onTrackpadZoomIn, false)
    //   zoomEL.addEventListener('trackpadZoomOut', this.onTrackpadZoomOut, false)
    //   zoomEL.addEventListener('touchZoom', this.onTouchZoom, false)
    //
    //   this.shouldScrollToRight ? this.scrollToRight(0) : this.scrollToLeft(0)
    //
    //   if (!this.isFullPageViewMode) {
    //     this.resetZoomToFitWidth(true, 0)
    //   } else {
    //     if (this.adsEnabled && this.isDesktop()) {
    //       this.zoomer.wrapperOffset.left = -370
    //     } else if (this.isPhone()) {
    //       this.zoomer.wrapperOffset.left = -50
    //     } else {
    //       this.zoomer.wrapperOffset.left = -70
    //     }
    //   }
    //
    //   this.zoomer.on('scrollStart', () => {
    //     this.$store.commit('setIsScrolling', true)
    //   })
    //
    //   this.zoomer.on('scrollEnd', () => {
    //     setTimeout(this.scrollEnded, 500)
    //   })
    //
    //   this.zoomer.on('zoomEnd', this.zoomAnimationDone)
    //   this.zoomer.on('trackpadZoomEnd', this.onTrackpadZoomEnd)
    //
    //   let self = this
    //   var prevScale = 1.0
    //   this.zoomer.on('trackpadZoomIn', () => {
    //     let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
    //     if (roundedScale !== prevScale) {
    //       self.fireZoomEvent('ActionPagesPageZoomTrackpadPinchIn')
    //     }
    //     prevScale = roundedScale
    //   })
    //   this.zoomer.on('trackpadZoomOut', () => {
    //     let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
    //     if (roundedScale !== prevScale) {
    //       self.fireZoomEvent('ActionPagesPageZoomTrackpadPinchOut')
    //     }
    //     prevScale = roundedScale
    //   })
    //   this.zoomer.on('touchZoomIn', () => {
    //     let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
    //     if (roundedScale !== prevScale) {
    //       self.fireZoomEvent('ActionPagesPageZoomTouchPinchIn')
    //     }
    //     prevScale = roundedScale
    //   })
    //   this.zoomer.on('touchZoomOut', () => {
    //     let roundedScale = Math.floor(self.zoomer.scale * 10) / 10
    //     if (roundedScale !== prevScale) {
    //       self.fireZoomEvent('ActionPagesPageZoomTouchPinchOut')
    //     }
    //     prevScale = roundedScale
    //   })
    // },
    // resetZoomToFitWidth (init, centerY, centerX) {
    //   if (this.zoomer === null) return
    //   var yValue = 0
    //   if (centerY !== undefined) {
    //     yValue = centerY
    //   }
    //
    //   var leftPageWidth = document.getElementById(this._uid + 'page-left-container').offsetWidth
    //   // if (this.page.firstPage.isSpread) {
    //   //   leftPageWidth = leftPageWidth / 2
    //   // }
    //   var pageWrapperWidth = document.getElementById(this._uid + 'page-wrapper').clientWidth
    //   let pageContainer = document.getElementById('pages-container')
    //
    //   var scale = 1.0
    //
    //   if (leftPageWidth > 0 && pageWrapperWidth > 0) {
    //     scale = pageWrapperWidth / leftPageWidth
    //     var xValue = pageContainer.clientWidth / 2
    //     if (centerX !== undefined) {
    //       xValue = centerX
    //     }
    //     if (this.isPhone()) {
    //       // if it is mobile sized -> offset by -50 (margin on left).
    //       this.zoomToLevel(scale, xValue, yValue, -50)
    //       // this.zoomer.wrapperOffset.left = -70
    //     } else if (init && this.adsEnabled && this.isDesktop()) {
    //       // This is the initial zoom when the zoomer is created. Also there are an ad on the left side.
    //       // the offset should be -370 but it is set to -70 when zooming... and then set to -370 for future zooming.
    //       // To be honest i don't know why we have to do this... But it works.
    //       this.zoomToLevel(scale, xValue, yValue, -70)
    //       this.zoomer.wrapperOffset.left = -370
    //     } else if (this.adsEnabled && this.isDesktop()) {
    //       this.zoomToLevel(scale, xValue, yValue, -370)
    //     } else {
    //       this.zoomToLevel(scale, xValue, yValue, -70)
    //     }
    //
    //     this.doubleClickZoomLevel = scale
    //   }
    // },
    scrollEnded () {
      if (this.pageZoomer === null) {
        return
      }
      if (this.pageZoomer.isLeftPageInView() && this.renderLeftPdfPageOnScroll) {
        this.renderLeftPdfPageOnScroll = false
        this.renderLeftPdfPage()
      }
      if (this.page.secondPage !== null) {
        if (this.pageZoomer.isRightPageInView() && this.renderRightPdfPageOnScroll) {
          this.renderRightPdfPageOnScroll = false
          this.renderRightPdfPage()
        }
      }
      this.$store.commit('setIsScrolling', false)
    },
    // reSizePageBitmap () {
    //   const pagesCont = document.getElementById('pages-container')
    //   const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
    //   const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
    //   const pageElemThumb1 = document.getElementById(this._uid + 'page-left-thumbnail')
    //   const pageElemThumb2 = document.getElementById(this._uid + 'page-right-thumbnail')
    //   const pageElemBitmap1 = document.getElementById(this._uid + 'page-left-bitmap')
    //   const pageElemBitmap2 = document.getElementById(this._uid + 'page-right-bitmap')
    //
    //   pageWrapper.style.height = pagesCont.style.height
    //
    //   if (this.isFullPageViewMode) {
    //     // Adjust height and width to fit "fit-to-height"
    //     // pages-container has the new max height
    //
    //     // set height of thumbs and bitmaps
    //     const pageWrapperWidth = pageWrapper.getBoundingClientRect().width
    //
    //     // re-size zoom wrapper
    //     zoomWrapper.style.height = pagesCont.style.height
    //     zoomWrapper.style.width = pageWrapperWidth + 'px'
    //
    //     // unset page widths
    //     pageElemThumb1.style.width = 'unset'
    //     pageElemBitmap1.style.width = 'unset'
    //
    //     pageElemThumb1.style.height = pagesCont.style.height
    //     pageElemBitmap1.style.height = pagesCont.style.height
    //     if (this.page.secondPage !== null) {
    //       pageElemThumb2.style.width = 'unset'
    //       pageElemBitmap2.style.width = 'unset'
    //       pageElemThumb2.style.height = pagesCont.style.height
    //       pageElemBitmap2.style.height = pagesCont.style.height
    //     } else {
    //       pageElemThumb2.style.width = '0px'
    //       pageElemBitmap2.style.width = '0px'
    //     }
    //
    //     // at this point the pages elements (thumbnail && pdf canvas) has a height equal to the height of the container.
    //     // But what if there is not enough space for the page(s) in width?
    //     // Then we should reduce the height of the page(s) to fit the width...
    //
    //     let pagesWidth = pageElemBitmap1.getBoundingClientRect().width + pageElemBitmap2.getBoundingClientRect().width
    //     if (pagesWidth > pageWrapperWidth) {
    //       const widthDiffFactor = pageWrapperWidth / pagesWidth
    //
    //       const newHeight = pageWrapper.getBoundingClientRect().height * widthDiffFactor
    //
    //       pageElemThumb1.style.height = newHeight + 'px'
    //       pageElemBitmap1.style.height = newHeight + 'px'
    //       if (this.page.secondPage !== null) {
    //         pageElemThumb2.style.height = newHeight + 'px'
    //         pageElemBitmap2.style.height = newHeight + 'px'
    //       }
    //     }
    //
    //     if (zoomWrapper.getBoundingClientRect().width < pageElemBitmap1.getBoundingClientRect().width) {
    //       zoomWrapper.style.width = pageElemBitmap1.getBoundingClientRect().width + 'px'
    //     }
    //   } else {
    //     // fit to width
    //     // get current width of pages
    //     const currentPagesWidth = pageElemBitmap1.getBoundingClientRect().width + pageElemBitmap2.getBoundingClientRect().width
    //
    //     // get available width
    //     const newWidth = pageWrapper.getBoundingClientRect().width
    //
    //     // width diff
    //     const widthDiffFactor = newWidth / currentPagesWidth
    //
    //     // new height
    //     const newHeight = Math.floor(pageElemBitmap1.getBoundingClientRect().height * widthDiffFactor)
    //
    //     // set width and height
    //     pageElemThumb1.style.height = newHeight + 'px'
    //     pageElemBitmap1.style.height = newHeight + 'px'
    //     pageElemThumb1.style.width = newWidth + 'px'
    //     pageElemBitmap1.style.width = newWidth + 'px'
    //
    //     zoomWrapper.style.height = newHeight + 'px'
    //     zoomWrapper.style.width = Math.floor(zoomWrapper.getBoundingClientRect().width * widthDiffFactor) + 'px'
    //   }
    // },
    displayFirstPageBitmap () {
      // thumbnails are loaded and displayed and the background bitmap is loaded but not yet displayed.
      const thumbnail = document.getElementById(this._uid + 'page-left-thumbnail')
      const bitmap = document.getElementById(this._uid + 'page-left-bitmap')

      if (bitmap === null || thumbnail === null) {
        return
      }

      // size the bitmap
      bitmap.style.height = thumbnail.style.height
      bitmap.style.width = thumbnail.style.width

      // hide thumbnail
      thumbnail.style.display = 'none'

      // display bitmap
      bitmap.style.display = 'block'
      bitmap.style.visibility = 'visible'
    },
    displaySecondPageBitmap () {
      if (this.page.secondPage === null) {
        // there is no second page
        return
      }
      // thumbnails are loaded and displayed and the background bitmap is loaded but not yet displayed.
      const thumbnail = document.getElementById(this._uid + 'page-right-thumbnail')
      const bitmap = document.getElementById(this._uid + 'page-right-bitmap')

      if (bitmap === null || thumbnail === null) {
        return
      }

      // size the bitmap
      bitmap.style.height = thumbnail.style.height
      bitmap.style.width = thumbnail.style.width

      // hide thumbnail
      thumbnail.style.display = 'none'

      // display bitmap
      bitmap.style.display = 'block'
      bitmap.style.visibility = 'visible'
    },
    displayPageThumbnails () {
      const thumbnail1 = document.getElementById(this._uid + 'page-left-thumbnail')
      if (thumbnail1 === null) {
        return
      }
      const bitmap1 = document.getElementById(this._uid + 'page-left-bitmap')

      // display thumbnail
      thumbnail1.style.display = 'block'

      // hide bitmap
      if (bitmap1) {
        bitmap1.style.display = 'none'
      }

      if (this.page.secondPage !== null) {
        const thumbnail2 = document.getElementById(this._uid + 'page-right-thumbnail')
        const bitmap2 = document.getElementById(this._uid + 'page-right-bitmap')

        // display thumbnail
        if (thumbnail2) {
          thumbnail2.style.display = 'block'
        }
        
        // hide bitmap
        if (bitmap2) {
          bitmap2.style.display = 'none'
        }
      }
    },
    sizePageThumbnails () {
      const pagesCont = document.getElementById('pages-container')
      const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
      const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
      const pageElemThumb1 = document.getElementById(this._uid + 'page-left-thumbnail')
      const pageElemThumb2 = document.getElementById(this._uid + 'page-right-thumbnail')

      if (pageWrapper === null) {
        return
      }

      pageWrapper.style.height = pagesCont.style.height

      if (this.isFullPageViewMode) {
        // the thumbnails should be as big as possible within the bounds of the page wrapper - while still being completely in view.

        // how much space in width is available for the pages
        const pageWrapperWidth = pageWrapper.getBoundingClientRect().width

        // the size of the zoom wrapper should just be the same as the page wrapper
        zoomWrapper.style.height = pageWrapper.style.height
        zoomWrapper.style.width = pageWrapperWidth + 'px'

        // calculate page elem width
        const pageObjHeight1 = parseFloat(this.page.firstPage.attributes.ObjectHeight)
        const pageObjWidth1 = parseFloat(this.page.firstPage.attributes.ObjectWidth)
        const heightFactor1 = pagesCont.getBoundingClientRect().height / pageObjHeight1
        const pageElemWidth1 = Math.floor(pageObjWidth1 * heightFactor1)

        pageElemThumb1.style.width = pageElemWidth1 + 'px'

        // fit to height
        pageElemThumb1.style.height = pagesCont.style.height

        let pageElemWidth2 = 0
        if (this.page.secondPage !== null) {
          // calculate page elem width
          const pageObjHeight2 = parseFloat(this.page.secondPage.attributes.ObjectHeight)
          const pageObjWidth2 = parseFloat(this.page.secondPage.attributes.ObjectWidth)
          const heightFactor2 = pagesCont.getBoundingClientRect().height / pageObjHeight2
          pageElemWidth2 = Math.floor(pageObjWidth2 * heightFactor2)

          pageElemThumb2.style.width = pageElemWidth2 + 'px'

          // fit to height
          pageElemThumb2.style.height = pagesCont.style.height
        } else {
          // hide second thumbnail if there is no second page
          // pageElemThumb2.style.width = '0px'

          // When displaying double pages - then resize the single pages (front page, spreads, etc.) as if they where double pages
          if (!this.isSinglePages()) {
            pageElemWidth2 = pageElemWidth1
          }
        }

        // at this point the page thumbnails has a height equal to the height of the wrapper.
        // But what if there is not enough space for the page(s) in width?
        // Then we should reduce the height of the page(s) to fit the width...
        let pagesWidth = pageElemWidth1 + pageElemWidth2
        if (pagesWidth > pageWrapperWidth) {
          if (this.page.secondPage === null) {
            const objectWidth = this.page.firstPage.attributes.ObjectWidth
            const sectionModelWidth = this.page.firstPage.attributes.SectionModelPageWidth
            if (objectWidth >= sectionModelWidth * 2) {
              // it is a spread page. divide it by 2 to pretend that it is a normal page for the calculations of the height.
              pagesWidth = pagesWidth / 2
            }
          }

          const widthDiffFactor = pageWrapperWidth / pagesWidth
          let newHeight = pagesCont.getBoundingClientRect().height
          if (widthDiffFactor < 1) {
            // Too high - reduce it.
            newHeight = Math.floor(pageWrapper.getBoundingClientRect().height * widthDiffFactor)
          }

          const heightFactor1new = newHeight / pageObjHeight1
          const pageElemWidth1new = Math.floor(pageObjWidth1 * heightFactor1new)

          pageElemThumb1.style.height = newHeight + 'px'
          pageElemThumb1.style.width = pageElemWidth1new + 'px'

          if (this.page.secondPage !== null) {
            const pageObjHeight2 = parseFloat(this.page.secondPage.attributes.ObjectHeight)
            const pageObjWidth2 = parseFloat(this.page.secondPage.attributes.ObjectWidth)
            const heightFactor2new = newHeight / pageObjHeight2
            const pageElemWidth2new = Math.floor(pageObjWidth2 * heightFactor2new)

            pageElemThumb2.style.height = newHeight + 'px'
            pageElemThumb2.style.width = pageElemWidth2new + 'px'
          }
        }

        // make sure the zoom wrapper wraps the thumbnails
        const pageThumb2Width = pageElemThumb2 ? pageElemThumb2.getBoundingClientRect().width : 0
        if (zoomWrapper.getBoundingClientRect().width < pageElemThumb1.getBoundingClientRect().width + pageThumb2Width) {
          zoomWrapper.style.width = (pageElemThumb1.getBoundingClientRect().width  + pageThumb2Width) + 'px'
        }
      } else {
        // Fit the thumnail to width
        // If in fit-to-width mode then we only display single pages.

        const currentPageWidth = pageElemThumb1.getBoundingClientRect().width

        // get available width
        let newWidth = pageWrapper.getBoundingClientRect().width

        const objectWidth = this.page.firstPage.attributes.ObjectWidth
        const sectionModelWidth = this.page.firstPage.attributes.SectionModelPageWidth
        if (objectWidth >= sectionModelWidth * 2) {
          // if it is a spread page then fit the width should be twice as big to make it appear as two single pages.
          newWidth = newWidth * 2
        }

        // relative width diff
        const widthDiffFactor = newWidth / currentPageWidth

        // new height
        const newHeight = Math.floor(pageElemThumb1.getBoundingClientRect().height * widthDiffFactor)

        // set width and height
        pageElemThumb1.style.height = newHeight + 'px'
        pageElemThumb1.style.width = newWidth + 'px'

        // make sure the zoom wrapper wraps the thumbnail
        zoomWrapper.style.height = pageElemThumb1.style.height
        // zoomWrapper.style.width = Math.floor(zoomWrapper.getBoundingClientRect().width * widthDiffFactor) + 'px'
        zoomWrapper.style.width = pageElemThumb1.style.width

        if (zoomWrapper.clientHeight < pageWrapper.clientHeight) {
          zoomWrapper.style.height = pageWrapper.style.height
        }
      }
    },
    sizeInterstitialAdPlaceholder () {
      const pagesCont = document.getElementById('pages-container')
      const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
      const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
      const adPlaceholder = document.getElementById(this._uid + 'interstitial-ad-container')

      if (!adPlaceholder) { return }

      pageWrapper.style.height = pagesCont.style.height
      zoomWrapper.style.height = pagesCont.style.height
      adPlaceholder.style.height = pagesCont.style.height

      adPlaceholder.style.width = pageWrapper.clientWidth + 'px'
    },
    // layoutPages () {
    //   if (this.page !== undefined && this.shouldLayoutPages) {
    //     const pagesCont = document.getElementById('pages-container')
    //     const pageElemThumb1 = document.getElementById(this._uid + 'page-left-thumbnail')
    //     const pageElemThumb2 = document.getElementById(this._uid + 'page-right-thumbnail')
    //     const zoomWrapper = document.getElementById(this._uid + 'zoom-wrapper')
    //     const pageWrapper = document.getElementById(this._uid + 'page-wrapper')
    //     if (pagesCont.style.height !== '') {
    //       pageElemThumb1.style.height = pagesCont.style.height
    //       pageWrapper.style.height = pagesCont.style.height
    //       zoomWrapper.style.height = pagesCont.style.height
    //       zoomWrapper.style.width = pageWrapper.offsetWidth + 'px'
    //     }
    //
    //     if (useBitmapPages) {
    //       pageElemThumb1.style.width = 'unset'
    //     }
    //
    //     if (this.page.secondPage !== null) {
    //       pageElemThumb2.style.height = pagesCont.style.height
    //       if (useBitmapPages) {
    //         pageElemThumb2.style.width = 'unset'
    //       }
    //     } else {
    //       pageElemThumb2.style.width = '0px'
    //     }
    //
    //     // at this point the pages elements (thumbnail && pdf canvas) has a height equal to the height of the container.
    //     // But what if there is not enough space for the page(s) in width?
    //     // Then we should reduce the height of the page(s) to fit the width...
    //
    //     let pagesWidth = pageElemThumb1.getBoundingClientRect().width + pageElemThumb2.getBoundingClientRect().width
    //     const pageWrapperWidth = pageWrapper.getBoundingClientRect().width
    //     let pageWrapperHeight = pageWrapper.getBoundingClientRect().height
    //
    //     if (pagesWidth > pageWrapperWidth) {
    //       if (this.page.secondPage === null) {
    //         const objectWidth = this.page.firstPage.attributes.ObjectWidth
    //         const sectionModelWidth = this.page.firstPage.attributes.SectionModelPageWidth
    //         if (objectWidth >= sectionModelWidth * 2) {
    //           // it is a spread page. divide it by 2 to pretend that it is a normal page for the calculations of the height.
    //           pagesWidth = pagesWidth / 2
    //         }
    //       }
    //
    //       const reducedWidthFactor = pageWrapperWidth / pagesWidth
    //       if (reducedWidthFactor < 1) {
    //         // Too high - reduce it.
    //         pageWrapperHeight = Math.floor(pageWrapperHeight * reducedWidthFactor)
    //       }
    //       pageElemThumb1.style.height = pageWrapperHeight + 'px'
    //       pageElemThumb1.style.width = Math.floor(pageElemThumb1.getBoundingClientRect().width) + 'px'
    //       if (this.page.secondPage !== null) {
    //         pageElemThumb2.style.height = pageWrapperHeight + 'px'
    //         pageElemThumb2.style.width = Math.floor(pageElemThumb2.getBoundingClientRect().width) + 'px'
    //       }
    //     }
    //
    //     if (zoomWrapper.offsetWidth < pageElemThumb1.offsetWidth) {
    //       zoomWrapper.style.width = pageElemThumb1.offsetWidth + 'px'
    //     }
    //
    //     pageElemThumb1.style.visibility = 'visible'
    //     if (this.page.secondPage !== null) {
    //       pageElemThumb2.style.visibility = 'visible'
    //     }
    //
    //     this.shouldLayoutPages = false
    //     return pageWrapperHeight
    //   }
    // },
    // zoomAnimationDone () {
    //   this.renderPdfPages()
    //   // make it a one-shot handler, but cannot de-register while in callback
    //   this.$nextTick(() => {
    //     this.zoomer.off('scrollEnd', this.zoomAnimationDone)
    //   })
    //   // tracking module needs to know when we are done with the animation:
    //   this.$store.commit('setIsZoomAnimating', false)
    //
    //   if (this.trackAnimateZoomEvent === 'ActionPagesPageZoomDoubleClickOut' ||
    //     this.trackAnimateZoomEvent === 'ActionPagesPageZoomDoubleClickIn' ||
    //     this.trackAnimateZoomEvent === 'ActionPagesPageZoomButtonClickIn' ||
    //     this.trackAnimateZoomEvent === 'ActionPagesPageZoomButtonClickOut') {
    //     this.fireZoomEvent('ActionPagesPageZoomDoubleClickOut')
    //     this.trackAnimateZoomEvent = ''
    //   }
    // },
    // zoomToLevel (zoomLevel, centerX, centerY, wrapperOffset) {
    //   if (zoomLevel > 1.0 && this.page.firstPage.id.indexOf('dummy') !== -1) {
    //     return
    //   }
    //   if (this.zoomer !== null && !this.isZoomAnimating) {
    //     this.$store.commit('setIsZoomAnimating', true)
    //     // NOTE: the IScroll module only sends 'scrollEnd' event when it's done animating
    //     this.zoomer.on('scrollEnd', this.zoomAnimationDone)
    //   }
    //   if (zoomLevel > 1.0) {
    //     if (this.zoomer !== null) {
    //       if (wrapperOffset !== undefined) {
    //         this.zoomer.wrapperOffset.left = wrapperOffset
    //       } else if (this.adsEnabled && this.isDesktop()) {
    //         // offset the zoom center point with the width of the left side ad and pageWrapper margin left.
    //         this.zoomer.wrapperOffset.left = -370
    //       } else if (this.isPhone()) {
    //         this.zoomer.wrapperOffset.left = -50
    //       } else {
    //         this.zoomer.wrapperOffset.left = -70
    //       }
    //       this.showThumbnails()
    //       this.zoomer.zoom(zoomLevel, centerX, centerY)
    //     }
    //   } else {
    //     if (this.zoomer !== null) {
    //       this.showThumbnails()
    //       this.zoomer.zoom(1)
    //     }
    //   }
    // },
    // sendClick (targetId) {
    //   /* Captured click was not a doubleclick, send a new click event to old target */
    //   /* eslint-disable no-undef */
    //   var event
    //   try {
    //     event = new MouseEvent('click', {
    //       view: window,
    //       bubbles: true,
    //       cancelable: true
    //     })
    //   } catch (e) {
    //     // Support for internet explorer...
    //     var mouseEvent = document.createEvent('MouseEvent')
    //     mouseEvent.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
    //
    //     mouseEvent.prototype = Event.prototype
    //
    //     window.MouseEvent = mouseEvent
    //     event = mouseEvent
    //   }
    //
    //   /* eslint-enable no-undef */
    //   const el = document.getElementById(targetId)
    //   if (el !== null) {
    //     el.dispatchEvent(event)
    //   }
    // },
    // onClick (event) {
    //   /* Take click events from children (see .capture above).
    //    *  Wait and see if it's a double click */
    //   if (event === undefined || this.settings.doubleClickZoomIncrease <= 0.0) {
    //     return // this click handler only handles doubleClick zoom
    //   }
    //
    //   if (this.clickCount === 0 && this.clickTimer) {
    //     /* This an event we created in sendClick, skip it here */
    //     return
    //   }
    //   if (++this.clickCount === 1) {
    //     event.preventDefault()
    //     event.stopPropagation()
    //     let targetId = event.target.id
    //     this.clickTimer = setTimeout(() => {
    //       this.clickCount = 0
    //       this.sendClick(targetId)
    //       this.clickTimer = null
    //     }, 300)
    //   } else if (this.clickCount === 2) {
    //     event.stopPropagation()
    //     clearTimeout(this.clickTimer)
    //     this.clickTimer = null
    //     this.clickCount = 0
    //   }
    // },
    // onDoubleClick (event, touch) {
    //   if (this.page.firstPage.id !== this.currentPage.firstPage.id || this.page.firstPage.id.indexOf('dummy') !== -1) {
    //     return
    //   }
    //   if (!this.canZoom()) {
    //     return
    //   }
    //   if (this.settings.doubleClickZoomIncrease <= 0.0) {
    //     return // this double click handler only handles doubleClick zoom
    //   }
    //   let isTouch = touch !== undefined ? touch : false
    //   var yValue = event.clientY
    //   var xValue = event.clientX
    //   if (isTouch) {
    //     yValue = event.changedTouches[0].clientY
    //     xValue = event.changedTouches[0].clientX
    //   }
    //   if (this.pageZoomer.scale !== this.pageZoomer.minScale) {
    //     this.pageZoomer.zoom(this.pageZoomer.minScale, xValue, yValue)
    //   } else {
    //     this.pageZoomer.zoom(this.doubleClickViewportScale, xValue, yValue)
    //   }
    //   // if (this.pageZoomer.scale !== this.doubleClickViewportScale) {
    //   //   // zoom in
    //   //   this.pageZoomer.zoom(this.doubleClickViewportScale, xValue, yValue)
    //   // } else {
    //   //   this.pageZoomer.zoom(this.pageZoomer.minScale, xValue, yValue)
    //   // }
    //   this.renderPdfPages()
    //
    //   // let zoomLevel
    //   // if (this.zoomer.scale > this.doubleClickZoomLevel && !this.isFullPageViewMode) {
    //   //   this.resetZoomToFitWidth(false, yValue, xValue)
    //   //   return
    //   // } else if (this.isFullPageViewMode && this.zoomer.scale > 1.0) {
    //   //   this.trackAnimateZoomEvent = 'ActionPagesPageZoomDoubleClickOut'
    //   //   zoomLevel = 1.0
    //   // } else {
    //   //   this.trackAnimateZoomEvent = 'ActionPagesPageZoomDoubleClickIn'
    //   //   zoomLevel = this.zoomer.scale + this.settings.doubleClickZoomIncrease
    //   //   if (zoomLevel > this.maxZoom) {
    //   //     zoomLevel = this.maxZoom
    //   //   }
    //   // }
    //   //
    //   // if (zoomLevel === this.zoomer.scale) return
    //   // this.zoomToLevel(zoomLevel, xValue, yValue)
    // },
    // onClickTap (event) {
    //   if (this.settings.doubleClickZoomIncrease <= 0.0) {
    //     return // this click handler only handles doubleClick zoom
    //   }
    //
    //   if (this.clickCount === 0 && this.clickTimer) {
    //     /* This an event we created in sendClick, skip it here */
    //     return
    //   }
    //   if (++this.clickCount === 1) {
    //     event.preventDefault()
    //     event.stopPropagation()
    //     let targetId = event.target.id
    //     this.clickTimer = setTimeout(() => {
    //       this.clickCount = 0
    //       this.sendClick(targetId)
    //       this.clickTimer = null
    //     }, 300)
    //   } else if (this.clickCount === 2) {
    //     event.stopPropagation()
    //     clearTimeout(this.clickTimer)
    //     this.clickTimer = null
    //     this.clickCount = 0
    //   }
    // },
    // onTouchTap (event) {
    //   if (this.settings.doubleClickZoomIncrease <= 0.0 || !this.isTouchBrowser()) {
    //     return // this click handler only handles doubleClick zoom
    //   }
    //
    //   if (this.clickCount === 0 && this.clickTimer) {
    //     /* This an event we created in sendClick, skip it here */
    //     return
    //   }
    //   if (++this.clickCount === 1) {
    //     event.preventDefault()
    //     event.stopPropagation()
    //     let targetId = event.target.id
    //     this.clickTimer = setTimeout(() => {
    //       this.clickCount = 0
    //       this.sendClick(targetId)
    //       this.clickTimer = null
    //     }, 300)
    //   } else if (this.clickCount === 2) {
    //     event.stopPropagation()
    //     clearTimeout(this.clickTimer)
    //     this.clickTimer = null
    //     this.clickCount = 0
    //     this.onDoubleClick(event, true)
    //   }
    // },
    getArticleInCenter () {
      var centerArticleId = null
      if (!this.$refs.articles) return centerArticleId

      for (let article of this.$refs.articles) {
        if (article.getArticleIfInCenter() !== undefined) {
          centerArticleId = article.getArticleIfInCenter()
        }
      }
      return centerArticleId
    },
    getPageInCenter () {
      if (this.page.secondPage === null) {
        return this.page.firstPage
      }
      const leftPageDiv = document.getElementById(this._uid + 'page-left-container')
      const leftPageRect = leftPageDiv.getBoundingClientRect()
      const rightPageDiv = document.getElementById(this._uid + 'page-right-container')
      const rightPageRect = rightPageDiv.getBoundingClientRect()

      const windowWidth = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth
      const windowHeight = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight
      const centerX = windowWidth / 2
      const centerY = windowHeight / 2

      const isRightCenter = (
        rightPageRect.bottom >= centerY &&
        rightPageRect.top < centerY &&
        rightPageRect.left <= centerX &&
        rightPageRect.right > centerX
      )
      const isLeftCenter = (
        leftPageRect.bottom >= centerY &&
        leftPageRect.top < centerY &&
        leftPageRect.left <= centerX &&
        leftPageRect.right > centerX
      )
      if (isLeftCenter) {
        return this.page.firstPage
      } else if (isRightCenter) {
        return this.page.secondPage
      }
    },
    // fireInitPageTrackingEvent () {
    //   if (this.initPage !== null) {
    //     this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', initPage.firstPage, initPage.firstPage.attributes.Page)
    //     if (initPage.secondPage !== null) {
    //       this.$cciEventTrackingPlugin.trackEvent('ContextPageView', 'ActionPagesPageView', initPage.secondPage, initPage.secondPage.attributes.Page)
    //     }
    //     // this.$cciTrackingPlugin.trackPageView(this.$cciTracking, this.initPage)
    //     this.initPage = null
    //   }
    //   window.removeEventListener('mi_micb_loaded', this.fireInitPageTrackingEvent)
    // },
    // destroyZoomer () {
    //   if (this.zoomer !== null) {
    //     this.zoomer.destroy()
    //     this.zoomer = null
    //   }
    // },
    destroyPageZoom () {
      if (this.pageZoomer !== null) {
        this.pageZoomer.zoomToMinScale()
        this.pageZoomer.destroy()
        this.pageZoomer = null
      }
    },
    zoomInFromButton () {
      if (this.canZoom()) {
        let newZoomScale = this._toFixedNumber(1.25 * this.pageZoomer.scale, 8)
        if (newZoomScale > this.pageZoomer.maxScale) {
          newZoomScale = this.pageZoomer.maxScale
        }
        // if (newZoomScale <= this.pageZoomer.maxScale) {
        this.cancelRenderPdfPages()
        this.pageZoomer.zoom(newZoomScale)
        const that = this
        clearTimeout(this.buttonZoomTimeout)
        this.buttonZoomTimeout = setTimeout(function() {
            // delay rendering
          that.renderPdfPages()
          that.fireZoomEvent('ActionPagesPageZoomButtonClickIn')
          that.buttonZoomTimeout = undefined
        }, 300)
        // }
      }
    },
    zoomOutFromButton () {
      if (this.canZoom()) {
        let newZoomScale = this._toFixedNumber(1/1.25 * this.pageZoomer.scale, 8)
        if (newZoomScale < this.pageZoomer.minScale) {
          newZoomScale = this.pageZoomer.minScale
        }
        // if (newZoomScale >= this.pageZoomer.minScale) {
        this.cancelRenderPdfPages()
        this.pageZoomer.zoom(newZoomScale)
        const that = this
        clearTimeout(this.buttonZoomTimeout)
        this.buttonZoomTimeout = setTimeout(function() {
            // delay rendering
          that.renderPdfPages()
          that.fireZoomEvent('ActionPagesPageZoomButtonClickOut')
          that.buttonZoomTimeout = undefined
        }, 300)
        // }
      }
    },
    handleZoomToElement(elem, isZoomAreaInViewport) {
      if (this.canZoom() && !this.isScrolling && this.isFullPageViewMode) {
        if (this.pageZoomer.scale === this.pageZoomer.minScale) {
          this.cancelRenderPdfPages()
          this.pageZoomer.zoomToElement(elem)
          const that = this
          clearTimeout(this.elementZoomTimeout)
          this.elementZoomTimeout = setTimeout(function() {
            // delay rendering
            that.renderPdfPages()
            that.elementZoomTimeout = undefined
          }, 300)
        } else if (isZoomAreaInViewport) {
          this.cancelRenderPdfPages()
          this.pageZoomer.zoomToMinScale()
          const that = this
          clearTimeout(this.elementZoomTimeout)
          this.elementZoomTimeout = setTimeout(function() {
            // delay rendering
            that.renderPdfPages()
            that.elementZoomTimeout = undefined
          }, 300)
        }
      }
    },
    fireZoomEvent (actionKey) {
      let article = this.getArticleInCenter()
      let roundedScale = Math.floor(this.pageZoomer.scale * 10) / 10
      if (article !== null) {
        this.$cciEventTrackingPlugin.trackEvent('ContextPageView', actionKey, article, 'scale: ' + roundedScale, roundedScale)
      } else {
        let page = this.getPageInCenter()
        if (page !== undefined) {
          this.$cciEventTrackingPlugin.trackEvent('ContextPageView', actionKey, page, 'scale: ' + roundedScale, roundedScale)
        }
      }
    },
    destroyCropper () {
      if (this.cropper !== null) {
        this.cropper.destroy()
        this.cropperOnScreen = false
        this.cropper = null
        enableSwiping()
      }
    },
    getPageFromSlideIndex () {
      if (this.pages) {
        for (var i = 0; i < this.slidesPageIndexes.length; i++) {
         if (this.slidesPageIndexes[i] === this.slideIndex) {
            return this.pages[i]
          }
        }
      }
    },
    isPageScrolledToRight () {
      var pageLeftContBoundingRect = document.getElementById(this._uid + 'page-left-container').getBoundingClientRect()
      var pageWrapperBoundingRect = document.getElementById(this._uid + 'page-wrapper').getBoundingClientRect()
      if (pageLeftContBoundingRect.width > pageWrapperBoundingRect.width && pageLeftContBoundingRect.height <= pageWrapperBoundingRect.height) {
        if (parseInt(pageLeftContBoundingRect.right, 10) <= parseInt(pageWrapperBoundingRect.right, 10)) {
          return true
        }
        return false
      }
      return true
    },
    isPageScrolledToLeft () {
      var pageLeftContBoundingRect = document.getElementById(this._uid + 'page-left-container').getBoundingClientRect()
      var pageWrapperBoundingRect = document.getElementById(this._uid + 'page-wrapper').getBoundingClientRect()
      if (pageLeftContBoundingRect.width > pageWrapperBoundingRect.width && pageLeftContBoundingRect.height <= pageWrapperBoundingRect.height) {
        if (parseInt(pageLeftContBoundingRect.left, 10) >= parseInt(pageWrapperBoundingRect.left, 10)) {
          return true
        }
        return false
      }
      return true
    },
    updateShouldScrollToRight (toRight) {
      this.shouldScrollToRight = toRight
      if (this.pageZoomer !== null) {
        this.shouldScrollToRight ? this.pageZoomer.scrollToRight() : this.pageZoomer.scrollToLeft()
      }
    },
    scrollToLeft () {
      if (this.pageZoomer !== null && !this.pageZoomer.isScrolledToLeft() && this.page.firstPage.isSpread && this.isSinglePages()) {
        this.pageZoomer.scrollToLeft()
        return true
      }
      return false
    },
    scrollToRight () {
      if (this.pageZoomer !== null && !this.pageZoomer.isScrolledToRight() && this.page.firstPage.isSpread && this.isSinglePages()) {
        this.pageZoomer.scrollToRight()
        return true
      }
      return false
    },
    onTrackpadZoomIn (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        this.cancelRenderPdfPages()
        this.renderPdfPages()
        this.fireZoomEvent('ActionPagesPageZoomTrackpadPinchIn')
      }
    },
    onTrackpadZoomOut (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        this.cancelRenderPdfPages()
        this.renderPdfPages()
        this.fireZoomEvent('ActionPagesPageZoomTrackpadPinchOut')
      }
    },
    onDoubleClickZoomIn (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id && !this.isRenderingLeftPdfPage && !this.isRenderingRightPdfPage) {
        this.cancelRenderPdfPages()
        useBitmapPages ? this.pageZoomer.enable() : this.pageZoomer.disable()
        const that = this
        clearTimeout(this.doubleClickZoomTimeout)
        this.doubleClickZoomTimeout = setTimeout(function() {
          // delay rendering
          that.renderPdfPages()
          that.fireZoomEvent('ActionPagesPageZoomDoubleClickIn')
          that.doubleClickZoomTimeout = undefined
        }, 300)
      }
    },
    onDoubleClickZoomOut (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id && !this.isRenderingLeftPdfPage && !this.isRenderingRightPdfPage) {
        this.cancelRenderPdfPages()
        useBitmapPages ? this.pageZoomer.enable() : this.pageZoomer.disable()
        const that = this
        clearTimeout(this.doubleClickZoomTimeout)
        this.doubleClickZoomTimeout = setTimeout(function() {
          // delay rendering
          that.renderPdfPages()
          that.fireZoomEvent('ActionPagesPageZoomDoubleClickOut')
          that.doubleClickZoomTimeout = undefined
        }, 300)
      }
    },
    onTouchZoomIn (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        this.cancelRenderPdfPages()
        this.renderPdfPages()
        this.fireZoomEvent('ActionPagesPageZoomTouchPinchIn')
      }
    },
    onTouchZoomOut (e) {
      if (this.page.firstPage.id === this.currentPage.firstPage.id) {
        this.cancelRenderPdfPages()
        this.renderPdfPages()
        this.fireZoomEvent('ActionPagesPageZoomTouchPinchOut')
      }
    },
    displayCropTool () {
      this.showLoadingSpinner = false
      this.pageZoomer.disable()
      if (this.currentPage.secondPage || !this.cropperOnScreen) {
        let pageSide = this.$store.state.pageSide
        var pageImage = useBitmapPages ? document.getElementById(this._uid + 'page-left-bitmap') : document.getElementById(this._uid + 'page-left-pdf')
        var cropPage = this.currentPage.firstPage
        if (pageSide !== undefined && pageSide === 1) {
          pageImage = useBitmapPages ? document.getElementById(this._uid + 'page-right-bitmap') : document.getElementById(this._uid + 'page-right-pdf')
          cropPage = this.currentPage.secondPage
        }
        let cropActionDiv = document.createElement('div')
        cropActionDiv.id = 'crop-action'
        var cropButton = document.createElement('button')
        cropButton.id = 'crop-button'
        var cancelButton = document.createElement('button')
        cancelButton.id = 'cancel-button'

        var self = this
        // First we check if you support touch, otherwise it's click:
        let touchEvent = 'ontouchstart' in window ? 'touchstart' : 'click'
        this.cropper = new Cropper(pageImage, {
          dragMode: 'none',
          zoomable: false,
          movable: false,
          cropmove: false,
          autoCropArea: 0.7,
          responsive: true,
          viewMode: 2,
          ready () {
            let cropperDiv = document.getElementsByClassName('cropper-container')[0]
            cropperDiv.style.zIndex = '500'
            let cropperBox = document.getElementsByClassName('cropper-crop-box')[0]
            cropActionDiv.appendChild(cropButton)
            cropActionDiv.appendChild(cancelButton)
            cropperBox.appendChild(cropActionDiv)

            let queryCropBut = document.querySelector('#crop-button')
            queryCropBut.page = cropPage
            queryCropBut.addEventListener(touchEvent, self.cropPage, false)

            let queryCancelBut = document.querySelector('#cancel-button')
            queryCancelBut.page = cropPage
            queryCancelBut.addEventListener(touchEvent, self.cancelCrop, false)

            self.cropperOnScreen = true
          }
        })
        pageImage.addEventListener('cropmove', (event) => {
          if (!this.cropperIsMoving) {
            this.cropperIsMoving = true
            this.pageZoomer.disable()
          }
        })
        pageImage.addEventListener('cropend', (event) => {
          this.cropperIsMoving = false
        })
      }
    },
    cropPage (e) {
      const page = e.currentTarget.page
      this.$cciEventTrackingPlugin.trackEvent('ContextCropView', 'ActionCropOkButtonClick', page, page.attributes.Page)

      e.stopImmediatePropagation()
      e.preventDefault()
      let croppedImageCanvas = this.cropper.getCroppedCanvas()
      // As some browser doesn't DataURL to open in tab, i.e Chrome, needed to get from blob and
      // also not all browser has support for toBlob method
      let ua = window.navigator.userAgent
      let vendor = navigator.vendor
      let iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i)
      let webkit = !!ua.match(/WebKit/i)
      let iOSSafari = iOS && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i) && !ua.match(/EdgiOS/i)
      let desktopSafari = /Safari/i.test(ua) && /Apple Computer/.test(vendor) && !/Mobi|Android/i.test(ua)
      let isIPadOsSafari = this.isTouchBrowser() && this.isSafari()
      if ((iOS || isIPadOsSafari) && !ua.match(/CriOS/i)) {
        let cropImg = croppedImageCanvas.toDataURL()
        let link = document.createElement('a')
        link.href = cropImg
        if (iOSSafari || isIPadOsSafari) {
          link.download = 'croppedImg.png'
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else if (desktopSafari) {
        let windowReference = window.open()
        /* eslint-disable no-undef */
        croppedImageCanvas.toBlob(function (blob) {
          let imageUrl = URL.createObjectURL(blob)
          windowReference.location = imageUrl
        })
        /* eslint-enable no-undef */
      } else if (typeof croppedImageCanvas.toBlob !== 'undefined') {
        /* eslint-disable no-undef */
        croppedImageCanvas.toBlob(function (blob) {
          let imageUrl = URL.createObjectURL(blob)
          window.open(imageUrl, '_blank')
        })
        /* eslint-enable no-undef */
      } else {
        let cropImgDataURL = croppedImageCanvas.toDataURL()
        let newWindow = window.open()
        newWindow.document.write('<img src="'+ cropImgDataURL + '"' + ' style="height: auto;' +
          '  max-width: 100%; display: block; margin: auto;" '+'/>')

      }
      if (this.cropper !== null) {
        e.currentTarget.removeEventListener(e.type, this.cropPage)
        this.$store.commit('setCropVisible', false)
      }
    },
    cancelCrop (e) {
      const page = e.currentTarget.page
      this.$cciEventTrackingPlugin.trackEvent('ContextCropView', 'ActionCropCancelButtonClick', page, page.attributes.Page)
      e.stopImmediatePropagation()
      e.preventDefault()
      e.currentTarget.removeEventListener(e.type, this.cancelCrop)
      this.$store.commit('setCropVisible', false)
    },
    freezeZoomGestures () {
      window.addEventListener('touchmove', this.handleFreezeZoomGesture, { passive: false }, false)
      window.addEventListener('pointermove', this.handleFreezeZoomGesture, { passive: false }, false)
      window.addEventListener('mousemove', this.handleFreezeZoomGesture, { passive: false }, false)
      window.addEventListener('wheel', this.handleFreezeZoomGesture, { passive: false }, false)
    },
    unFreezeZoomGestures () {
      window.removeEventListener('touchmove', this.handleFreezeZoomGesture, false)
      window.removeEventListener('pointermove', this.handleFreezeZoomGesture, false)
      window.removeEventListener('mousemove', this.handleFreezeZoomGesture, false)
      window.removeEventListener('wheel', this.handleFreezeZoomGesture, false)
    },
    handleFreezeZoomGesture (e) {
      if ((e.type === 'touchmove' || e.type === 'pointermove' || e.type === 'mousemove') && e.touches && e.touches[1]) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
      if (e.type === 'wheel' && e.ctrlKey) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    },
    canZoom () {
      return this.leftPageLoaded && this.rightPageLoaded && !this.isRenderingLeftPdfPage && !this.isRenderingRightPdfPage && this.pageZoomer !== null && (this.pageZoomer.hasPdfs() || useBitmapPages) && this.page.firstPage.id === this.currentPage.firstPage.id
    },
    onPageDidZoom () {
      this.pageZoomer.scale > this.pageZoomer.minScale ? this.$store.commit('addZoomedPage', this.page) : this.$store.commit('removeZoomedPage', this.page)
      this.layoutZoomButtons()
    },
    layoutZoomButtons () {
      const zoomInElem = document.getElementById('nav-zoom-in')
      const zoomOutElem = document.getElementById('nav-zoom-out')

      if (zoomInElem === null || zoomOutElem === null) {
        return
      }

      if (!this.isCurrentPageLoaded) {
        zoomInElem.classList.remove('nav-icon-zoom-in')
        zoomInElem.classList.add('nav-icon-zoom-in-disable')

        zoomOutElem.classList.add('nav-icon-zoom-out-disable')
        zoomOutElem.classList.remove('nav-icon-zoom-out')
        return
      }

      if (this.pageZoomer !== null && this.pageZoomer.scale >= this.pageZoomer.maxScale) {
        // only display zoom out button
        zoomInElem.classList.remove('nav-icon-zoom-in')
        zoomInElem.classList.add('nav-icon-zoom-in-disable')

        zoomOutElem.classList.add('nav-icon-zoom-out')
        zoomOutElem.classList.remove('nav-icon-zoom-out-disable')
      } else if (this.pageZoomer !== null && this.pageZoomer.scale <= this.pageZoomer.minScale) {
        // only display zoom in button
        zoomInElem.classList.add('nav-icon-zoom-in')
        zoomInElem.classList.remove('nav-icon-zoom-in-disable')

        zoomOutElem.classList.add('nav-icon-zoom-out-disable')
        zoomOutElem.classList.remove('nav-icon-zoom-out')
      } else {
        // display both zoom buttons
        zoomInElem.classList.add('nav-icon-zoom-in')
        zoomInElem.classList.remove('nav-icon-zoom-in-disable')

        zoomOutElem.classList.add('nav-icon-zoom-out')
        zoomOutElem.classList.remove('nav-icon-zoom-out-disable')
      }
    },
    destroyCanvases () {
      // cancel any ongoing rendering.
      if (this.isRenderingLeftPdfPage && this.leftPageRenderingTask !== null) {
        this.leftPageRenderingTask.cancel()
      }
      if (this.isRenderingRightPdfPage && this.rightPageRenderingTask !== null) {
        this.rightPageRenderingTask.cancel()
      }
    
      if (this.leftPageLoadingTask !== null) {
        this.leftPageLoadingTask.destroy()
      }
    
      if (this.rightPageLoadingTask !== null) {
        this.rightPageLoadingTask.destroy()
      }
    
      this.unFreezeZoomGestures()
    
      // zoom out and clear the pdf components from the page zoomer
      if (this.pageZoomer !== null) {
        this.pageZoomer.zoomToMinScale()
        this.pageZoomer.removeEvents()
      //   this.destroyPageZoom()
      }
    
      // reset the pdf rendering related global variables.
      this.leftPdfPage = null
      this.rightPdfPage = null
      this.leftPageLoaded = false
      this.rightPageLoaded = false
      this.isRenderingLeftPdfPage = false
      this.isRenderingRightPdfPage = false
      this.leftPageRenderingTask = null
      this.rightPageRenderingTask = null
      this.leftPageLoadingTask = null
      this.rightPageLoadingTask = null
    
    
      // remove the canvas elements
      const leftCanvas = document.getElementById(this._uid + 'page-left-pdf')
      const rightCanvas = document.getElementById(this._uid + 'page-right-pdf')
      if (leftCanvas !== null) {
        leftCanvas.remove()
      }
      if (rightCanvas !== null) {
        rightCanvas.remove()
      }
    
      // remove text layer elements
      const leftTextLayer = document.getElementById(this._uid + 'page-left-text-layer')
      const rightTextLayer = document.getElementById(this._uid + 'page-right-text-layer')
      if (leftTextLayer !== null) {
        leftTextLayer.remove()
      }
      if (rightTextLayer !== null) {
        rightTextLayer.remove()
      }
    },
    displayAdPlaceholder () {
      const adDiv = document.getElementById(this._uid + 'interstitial-ad-container')
      adDiv.style.display = 'block'
      const maxWidth = document.getElementById(this._uid + 'page-wrapper').clientWidth
      const maxHeight = document.getElementById('pages-container').clientHeight
      adDiv.style.width = maxWidth + 'px'
      adDiv.style.height = maxHeight + 'px'
      // adDiv.style.transform = 'translate(0, 50%)'

      const eventDetail = {
        containerElementId: this._uid + 'interstitial-ad-container'
      }
      var event = new CustomEvent('displayInterstitialAd', { detail: eventDetail })
      window.dispatchEvent(event)
    },
    _toFixedNumber (num, digits, base) {
      var pow = Math.pow(base||10, digits)
      return Math.round(num*pow) / pow
    },
    indexOfPage (pages, page) {
      for (var i = 0; i < pages.length; i++) {
        if (pages[i].firstPage.id === page.firstPage.id) {
          return i
        }
      }
      return -1
    },
    fireInterstitialAdPageWillBeDestroyedEvent() {
       const eventDetail = {
        containerElementId: this._uid + 'interstitial-ad-container'
      }
      const event = new CustomEvent('interstitialAdPageWillBeDestroyed', { detail: eventDetail })
      window.dispatchEvent(event)
    }
  },
  beforeDestroy () {
    if (this.page !== undefined && this.page.firstPage.isInterstitialAdPlaceholder) {      
      // The page that will be destroyed contains an ad.
      this.fireInterstitialAdPageWillBeDestroyedEvent()
    }

    // window.removeEventListener('mi_micb_loaded', this.fireInitPageTrackingEvent, false)
    window.removeEventListener('buttonZoomIn', this.zoomInFromButton, false)
    window.removeEventListener('buttonZoomOut', this.zoomOutFromButton, false)
    window.removeEventListener('pdfjsloaded', this.startPdfLoading, false)

    this.destroyCropper()
    this.unFreezeZoomGestures()

    if (this.isRenderingLeftPdfPage && this.leftPageRenderingTask !== null) {
      this.leftPageRenderingTask.cancel()
    }
    if (this.isRenderingRightPdfPage && this.rightPageRenderingTask !== null) {
      this.rightPageRenderingTask.cancel()
    }

    this.shouldLayoutPages = true

    this.destroyPageZoom()
  },
  components: {
    CciArticleLayer,
    CciClickableAdLayer,
    CciWidgetLayer,
    CciZoomAreaLayer
  }
}
